module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Chapter 2")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Pudding Island")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("But he for whom steel and running water")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Were roads, went westward only")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("To the prudish cliffs and the sad green home")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Of Pudding Island o’er the Victorian foam.")]), _vm._v(" "), _c('p', {
    staticClass: "blocka"
  }, [_vm._v("‘Cities, Plains and People’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Lawrence Durrell was disappointed by his first sight of England, and he gave his own feelings to Walsh Clifton in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" as the boy watched the land materialize:")])]), _c('p', {
    staticClass: "noindent1_"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("It would perhaps be impossible to define accurately the feeling of disappointment he experienced as he stood on the deck of the liner and watched the pearly cliffs insinuate themselves out of the light sea-haze; at any rate, he was not impressed by what he saw, and as he leaned his chin upon the rail, he told himself bitterly that it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smaller")]), _vm._v(" than he had imagined!")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn1",
      "id": "ich02fn1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Like Walsh, Larry felt ‘galled by his own lack of excitement: by his own apathy’, and ‘sick with an undefined regret, as though the beauty of the hills which he had left behind forever still worked in him.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn2",
      "id": "ich02fn2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" This sense of India left ‘forever’ compromised Larry’s natural interest in everything new. His parents were beset by no such misgivings. This was the Promised Land that they had imagined from the Pisgah of the Northern Frontier. Louisa eagerly took in the marvellous English gardens, the stately homes, the fashionable shops. Lawrence Samuel Durrell, thirty-nine-year-old railway engineer and contractor, found England in the summer of 1923 exhilarating. Here was the home of the scientific and industrial progress that he had been trying with messianic fervour to bring to India. The English trains moved with crisp clicking sounds, chanting, according to Larry, God Save The King, God Save The King,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn3",
      "id": "ich02fn3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])]), _vm._v(" over track laid as true as glass. The streets of London were packed with motor cars and soon Lawrence Samuel bought a little ‘bullnose’ Morris Cowley. The family visited the Bucks at ‘lax unmanning Eastbourne’, as Larry was much later to call it."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn4",
      "id": "ich02fn4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])]), _vm._v(" But he was delighted to see Aunt May and Uncle Cecil and to hear all the familiar talk "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("about India. There were visits to other relatives, including Lawrence Samuel’s cousins Harry and Elsie Rickwood in London, but all too soon it was time for Larry’s parents to return to Durrell & Co. in Jamshedpur. They left towards the end of September, lending the Morris Cowley to Cecil Buck and placing Larry at a school in Tunbridge Wells, a favourite retirement spot for those returned from service in India.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn5",
      "id": "ich02fn5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the year Larry spent at Tunbridge Wells he felt rather in limbo, in suspension: he was not assigned to a specific form or syllabus, but was supposed to pick up a few subjects until he could be placed permanently."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn6",
      "id": "ich02fn6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" And he had lost another half-year by being kept out of school while the family prepared for the trip to England—evidence of Louisa’s indulgence of her son, and also of her reluctance to be parted from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s impressions of England were not improving: ‘I immediately sensed the hypocrisy there and the puritanism,’ he would recall."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn7",
      "id": "ich02fn7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])]), _vm._v(" The damp cold, and even more the darkness, of the English winter depressed him. Most important, there was the severance of his attachment to his mother: the geographic gulf between them seemed unbridgeable. When he had been at St Joseph’s he had known that a rapid train journey could restore him to his family—would, in an emergency, bring his mother to him. In England, he could die before his parents even knew he was ill. Or they could die! He felt the wrenching agony of the child sent far from home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Looking back from a safe distance of forty-five years, Durrell claimed that his feelings towards England had been determined by his parents. Admitting that he hated England, he said, ‘I can give a Freudian explanation for it! Here goes! It was my father who decided to send me to England…. I attack England because I identify it with my father.’ He continued, ‘I reacted with everything I had against England, primarily in order to break my father’s will.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn8",
      "id": "ich02fn8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])]), _vm._v(" Only, Larry the schoolboy could not say that his reaction to England was part of an unacknowledged duel with his father. England he could react against; the underlying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reason")]), _vm._v(" had to remain a secret, probably at the time even from himself. Introspection and subterfuge became habitual: silent thoughts and misleading utterances. These factors were uniting to turn him into a writer. The replacement of maternal India by paternal England would bruise Larry into a cry of anguish, one eventually channelled into a literature that would strive constantly to escape England. The writer about exotic places would spring from the adolescent sick for India.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s depression was not alleviated next summer by a visitor from "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("India: Big Granny was in Eastbourne by early June. She was clad, typically, in black silk with soiled lace at the wrists,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn9",
      "id": "ich02fn9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])]), _vm._v(" and she was still ranting about God and death. Her face and hands were like dough and were covered with age spots. Larry would record the ravages of time in his description in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" of ‘Grandmamma’ as she appeared to Walsh in London: ‘The blank light moulded her heavy, loose-fleshed face, setting the pouches wide about the sagging mouth, and the blue loops of skin about her eyes.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn10",
      "id": "ich02fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By September 1924 Larry was lodged with Mrs. E. M. Dyson at 36 Hillsborough Road in Dulwich, a spacious south London suburb a reasonable commuting distance from the school that Larry was to attend, St Olave’s and St Saviour’s in Southwark. Dulwich was defined by the substantial yet self-deprecating middle-class homes with their dark, circumspect parlours and gloomy stairwells, creating an air of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pudeur")]), _vm._v(". A few streets from Mrs. Dyson’s stood Dulwich College, which was ‘a fair candidate for the wildest nineteenth century building in the whole of London’, with ‘a crazy Dostoevskian gleam in its eye.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn11",
      "id": "ich02fn11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])]), _vm._v(" In nearby Dulwich Park Larry would note a ‘cold toy lake’ that was home to ‘a few bedraggled swans.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn12",
      "id": "ich02fn12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])]), _vm._v(" Picture all this covered with a liberal patina of soot from bituminous coal and view it through a winter drizzle, and you will have a fair idea of why London appalled the boy from India. The raw, grey climate and the drab faces he saw matched Larry’s feeling of having been abandoned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Dyson was quite likely related to R. C. Dyson, a consulting engineer for railways to the Government of India in Calcutta, and an associate of Lawrence Samuel’s, so an Indian connection may have existed."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn13",
      "id": "ich02fn13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])]), _vm._v(" However, Mrs. Dyson was not a sympathetic presence. She was characterized by ‘ferocious probity and total lack of sensibility or imagination’, said Larry, and she was only one of a type common in Dulwich. ‘Here I found actually the world of Dickens still in force’, he continued, ‘with caricature figures giving off waves of guilt one could literally smell like BO.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn14",
      "id": "ich02fn14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])]), _vm._v(" In old age Durrell would decide that a major difference between himself and the native English lay in this guilt: ‘They have such a sense of sin which I don’t have.’ Defiantly, he added, ‘I believe in original innocence.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn15",
      "id": "ich02fn15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])]), _vm._v(" Fortunately, there was a fellow-sufferer at Mrs. Dyson’s, a boarding boy of Larry’s age named Malcolm Ayres. They became friends, and Larry admired Joan, Malcolm’s ‘very beautiful’ older sister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While he may have denied having a sense of sin, Larry carried a considerable burden of guilt which had nothing to do with social or sexual morality: he was very conscious of the money that was being spent on him "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("to make him English")]), _vm._v(", and with a part of himself he felt that the goal was hopeless, much as he wanted to fit in and please his parents. A code had been impressed upon him: ‘he was to be a man’ who would not cry when hurt; he must ‘endeavour to live up to’ being English; he must enjoy and be grateful for his English schooling. He projected his feelings on to Walsh Clifton, newly arrived in England: ‘He was abjectly, slavishly intent on becoming English; and indeed, if you had seen him dressed in his sober school clothes, with his immaculate, washable rubber-composition collar, and his hair soothed back off his forehead, you might have mistaken him for one of your own.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn16",
      "id": "ich02fn16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])]), _vm._v(" The smug ambience of Dulwich, however, worked against Larry’s assimilation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Mrs. Dyson’s home Larry went by tram or train to Southwark, then walked along Tooley Street to St Olave’s and St Saviour’s, an old-fashioned grammar school, where he was enrolled in Class II, with boys about two years his junior. St Olave’s, now South London College, was housed in a red brick three-storey Victorian structure set amid dockyards and warehouses on the south bank of the Thames, across the river from the Tower of London. The school was ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("socially")]), _vm._v(", very small fry compared to a real public school,’ Larry would come to recognize."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn17",
      "id": "ich02fn17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])]), _vm._v(" The plan was for Larry to pick up enough subjects to be able to pass the Common Entrance Examination, a prerequisite for his admission to a reputable public school, and he studied at St Olave’s until four each afternoon with that aim. He had a ‘marvellous english teacher’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn18",
      "id": "ich02fn18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])]), _vm._v(" who took his pupils on tours to the sites of the Rose and Swan theatres and other nearby places of the Elizabethan renaissance. ‘We learned our Shakespeare on the spot,’ Larry recalled. ‘We felt very much part of the Shakespearean scene, so to speak.’ A few streets beyond Southwark Cathedral the Globe Playhouse had stood, and beyond that Larry could walk along Bear Gardens Lane to the Thames. ‘It was great fun’, he said, ‘to realize that Shakespeare and company had been trotting around there the whole time.’ Although many of the masters spoke ‘a good deal of cockney’, Larry found them very good, and the discipline was not brutal: ‘We used to get slippered a great deal for minor offences, but a slipper over the bottom, a couple of whacks, is not really an execution.’ Larry would maintain that ‘the grammar schools were always much better than the public schools, their curricula and everything else were much more serious: it was just the snobbery of the class structure.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn19",
      "id": "ich02fn19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])]), _vm._v(" Precisely this higher class structure was what Lawrence Samuel wanted his son to enter. The egalitarian air of St Olave’s moved Larry subtly away from the snobbery of class and money; and the space between father and son widened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Larry told his family that he wanted to become a writer. Perhaps to his surprise, his father did not object:")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "noindentf"
  }, [_vm._v("He said that was okay but that I must go to Oxford first. His view was that all writers should go to Oxford where they made very influential friends who helped them to become successful afterwards. Perhaps this was not so silly as it then seemed. But he had read in the paper that Bernard Shaw had three Rolls-Royces and Kipling two—he wanted me to enjoy this sort of success; but I wanted a typewriter and if such a thing had been possible, an elephant.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("This seemed a perfectly reasonable shopping list. Larry ‘got the typewriter for Christmas, and a complete Shakespeare’, but no elephant.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn20",
      "id": "ich02fn20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s father also bought him a set of Dickens: here was another writer who had made a good living by his pen."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn21",
      "id": "ich02fn21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])]), _vm._v(" Larry, who had found Dickens dull in India, now read him with appreciation. Just off nearby Borough High Street was Lant Street, where Dickens had lodged in his boyhood while his father was in the debtors’ cells of the Marshalsea, birthplace of Little Dorrit. Although the gloomy prison had been demolished in Dickens’s lifetime, various settings for his novels were still extant and were well within the range of Larry’s lunchtime patrols. It was on the steps leading from the carriageway of London Bridge down to the river that Noah Claypole in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oliver Twist")]), _vm._v(", hiding behind a pilaster, eavesdropped on the conversation that would lead to Nancy’s murder by Bill Sikes. Lizzie Hexam in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Mutual Friend")]), _vm._v(" rowed her father between the Southwark and London bridges in his nightly search for the bodies of the drowned. And it was in the yard of the White Horse Inn off Borough High Street that Mr. Pickwick met Sam Weller cleaning boots. English literature was coming alive for Larry in a way that modern England, suffering from the comparison with India, could not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Larry was appreciative of Dickensian London, it was the Elizabethans and the Jacobeans who gained his lifelong allegiance. Sometimes the schoolboys were taken to Southwark Cathedral for services: ‘They were always occasions of some sort or other—the Lord Mayor, accompanied … by a display, the guilds, for example, in uniform, and that was very colourful.’ The boys of St Olave’s were lined up to march in procession. The pageantry of it all attracted Larry: ‘Very picturesque—the English have a good sense of theatre, you know’, he added parenthetically, ‘and one could see that the Elizabethan theatre must have had that thoroughness of function.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn22",
      "id": "ich02fn22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])]), _vm._v(" As a member of the school debating society, Larry argued—and was judged to have won his point—for continuing the tradition of the Lord Mayor’s Show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Larry’s future scheme for an Elizabethan book was born on the very ground, here in Southwark. Some days he hurried east along Tooley Street to spend his lunch hour in Southwark Cathedral, and his visits lengthened into truancy. There were many intriguing monuments to muse over. Richard Humble, a Jacobean notable, was sculpted kneeling on top of his sarcophagus, with his two wives in like pious pose ranked behind him. Lancelot Andrewes, seventeenth-century Bishop of Winchester, reposed under a magnificent gilded wooden canopy. Perhaps the brilliance and graphic detail of the painted monuments, then recently restored, reminded the lonely boy of India, and seemed a promise that the world of light and colour he had known had not been utterly vanquished by black and grey London. Roguish carved faces grinned down from the roof bosses in the wooden ceiling. He particularly admired the green and red painted tomb—bright as any Hindu shrine—of John Gower, friend of Chaucer.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("When his English teacher discovered where the boy was hiding during lesson time, instead of punishment he suggested, without a trace of irony, that since Master Durrell liked the farded monuments of Old England so much, he should read the literature of the past. Larry’s evaluation for 1924 states, ‘He has a genuine taste for English literature, and reads much on his own account.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn23",
      "id": "ich02fn23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])]), _vm._v(" Thus grew Larry’s acquaintance with the writers of the English renaissance, a passion he pursued so avidly that he would claim, with perhaps only a modicum of exaggeration, that by the age of seventeen he had read every surviving Elizabethan work."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn24",
      "id": "ich02fn24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("24")])]), _vm._v(" Certainly he adopted their adoration of spectacle and their word-love. As he would announce a decade later to Henry Miller, ‘Words I carry in my pocket where they breed like white mice …. Words belonging to trades stick to my tongue. I’m a fiendish reader for mere syllables.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn25",
      "id": "ich02fn25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("25")])]), _vm._v(" Larry’s general progress was judged satisfactory, and he was moved up to Class III for the new year.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Louisa Durrell arrived in 1925 for another visit. Travelling with Leslie, Margaret, the three-month-old Gerry and a nurse, she had left by P & O steamer from Bombay on 28 March for the three-week run to London."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn26",
      "id": "ich02fn26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("26")])]), _vm._v(" Lawrence Samuel had too much work in hand to take a long vacation and would not come to England until mid-summer. Not long before, he and John Dixie had quarrelled violently over a construction accident. A wall had collapsed, and there was loss of life. Dixie blamed the cost-cutting measures of the Indian partners for the mishap, while Lawrence Samuel supported the two Sikhs, maintaining that they should remain partners in the company. ‘Then "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m")]), _vm._v(" leaving!’ John Dixie said. While "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Louisa, Stella and their children stood aghast, the two men shouted recriminations at one another on the platform of the railway station in Jamshedpur. Although Stella Dixie and her two daughters would slip over occasionally to Jamshedpur to see Louisa, the men did not become reconciled and John withdrew from the company.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn27",
      "id": "ich02fn27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("27")])]), _vm._v(" The break with his friend and brother-in-law dulled Lawrence Samuel’s pleasure in the five-year accomplishments of the firm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What Lawrence Samuel found after he had rejoined his family ‘got him very excited’, as it had before, Larry remembered. In August they all travelled from London down to Eastbourne to see the Bucks. Larry’s father loved England in a way that his eldest son could not. For Lawrence Samuel it was wonderful to explore the country: his scientific mind thrilled to the factories and the industrial exhibitions; and he discovered the heady excitement of the London stage—as his son would a few years later. In any event, he had ‘got fed up’ with India and ‘the limitations of Indian life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn28",
      "id": "ich02fn28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("28")])]), _vm._v(" The construction industry was slowing down and the agitations of the nationalists were continuing. He began to think seriously of leaving India, moving to England, and taking up a stage career. He would partner Evelyn Laye, he dreamed! Before returning to India, Louisa and Lawrence Samuel enrolled Leslie as a day boy at Dulwich; later he would attend Caldicott, a Wesleyan Methodist school. Larry’s dislike of formal education seemed to be growing, and he dropped from eleventh to twenty-first in a class of thirty-three. Still, he was not a discipline problem at school, and the report at the end of the year noted that he was eager to please but ‘frivolous’: ‘He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" frequently answers the question that is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" asked,’ wrote his form master."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn29",
      "id": "ich02fn29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leslie was by now a virtual stranger to Larry, who looked upon his brother—when he was forced to include the much younger boy in his games—as a pest. His delicate health had made Leslie his mother’s pet, which Larry resented passionately. Leslie was miserable. He hated his lessons and did not develop Larry’s compensating interest in literature, but searched the magazines for accounts of hunting and pictures of guns, subjects that reminded him of India. Speaking for himself, Larry recalled, ‘I was a savage,’ and when a classmate ventured to tease him about ‘swotting’—being too studious—he would simply punch him on the nose and go back to his books—which were, to be sure, usually not school set books."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn30",
      "id": "ich02fn30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("30")])]), _vm._v(" Leslie, who according to Larry ‘might have been a very good painter’, found that the tough schoolboy world scorned such activities as sketching and painting. He lacked the vitality and the precocious intelligence of his older brother and was thus more vulnerable, but like Larry he had a fierce temper "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("and lashed out with his fists when crossed. Soon he too turned into a young savage, but one whose wildness was unrelieved by intellectual interests. Fighting became an end in itself for Leslie. During one of his brawls he sustained a beating that left him with a ruptured ear-drum and permanent deafness. Of Dulwich and its inhabitants Larry would recall, ‘I hated it and them but as I was tough, resilient and innocent-sexy I was not as much damaged by this Pentonville period as my brother Leslie.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn31",
      "id": "ich02fn31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])]), _vm._v(" Pentonville Prison became Larry’s metaphor for his London school years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next summer, taking advantage of the slowing down of construction work during the monsoons, the Durrells were back in England. In June 1926, before leaving India, Lawrence Samuel had produced an impressive illustrated brochure outlining in nearly a hundred pages the achievements of Durrell & Co., and he was sure that he could sell his interest in the firm for a good sum. In any case, after initially planning to move his headquarters to Calcutta, he had decided to relocate in Lahore, far to the west. He still considered leaving India permanently, and bought an eight-bedroom house in Dulwich at 48 Alleyn Park Road. The house was spacious, with high ceilings in the downstairs rooms, and it was set back a reasonable distance from the road in a long garden. There was the usual round of visits: the Rickwoods in Dulwich, the Bucks in Eastbourne. Louisa was shocked by Leslie’s battered condition and convinced her husband that they should take him back to India with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The family visits do not seem to have created an improved understanding between Larry and his father. Larry was still not happy to be at school in England, but he did not voice his complaints. Lawrence Samuel, on his part, was disappointed by his son’s academic performance, especially his apparent inability to master the rudiments of mathematics, but he did not lecture him nor call him to account. ‘He took me out and fed me buns,’ Larry said, evasively, when asked whether his father had scolded him."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn32",
      "id": "ich02fn32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the surface, Larry was on the way to becoming what his father wanted: an Empire-builder in the making, scarcely distinguishable in manners and speech from thousands of other sons of respectable and ambitious folk. There was an inward change too, but it was not one of which Lawrence Samuel would have approved, had he detected the signs—which he almost certainly did not. Throughout most of his time in India, Larry had been confident of his abilities and quite assured about his future. He had felt equally at home in Anglo-Indian society and in the native bazaars.")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("When I was only 9 or 10")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("I felt more secure than many men,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn33",
      "id": "ich02fn33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("he would write in 1940, adding a wry comment on the blows that ‘fate’ had dealt him in the intervening years. These blows had begun to fall during his first year in England, and he responded with some of the means at his disposal: pretence, silence, lies. At the age of fourteen he was still only four feet seven, and he compensated for his shortness with bravura and pugnacity. If survival and independence meant developing an easy outward show to protect his emotional vulnerability, to shield his fantasies against ridicule, so be it. To his father he professed contentment, even happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before Lawrence Samuel left England in September, he enrolled Larry in the Fourth Form, Grade B, at St Edmund’s School, established in Canterbury by the Clergy Orphan Society. Since beginning Fourth Formers were usually thirteen or fourteen years old, this meant that Larry was not appreciably behind in his studies, despite his later claims. He was lodged in Watson House, where most of the pupils were in the Senior School.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although not one of the famous public schools, St Edmund’s was sufficiently respectable. Eton, Harrow, or any other top-ranked school was out of the question: Larry’s education had been too spotty, his mathematical and science preparation too weak, and there were no influential Old Boys in the family to put in a word for him. Larry was certainly neither a clergyman’s son nor an orphan, but this did not bother the St Edmund’s trustees, who were content to supplement the rolls of the charity boarders with the sons of colonial gentlemen. Larry was among the few fee-paying non-foundationers, so that, as at St Joseph’s, he belonged to an insignificant minority. This time, however, he was not to be excused from religious instruction and chapel services: the school had strong Anglican affiliations, and preparation for confirmation was part of the curriculum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry must have noted the pleasing coincidence of his having begun his education in London at the starting point of Chaucer’s great pilgrimage, and then continued it in Canterbury. Larry remembered the place as ‘a most beautiful public school … whose architecture and atmosphere resembled very closely the school I had quitted in Darjeeling.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn34",
      "id": "ich02fn34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])]), _vm._v(" Neo-Gothic St Edmund’s rose towards the sky in rough Kentish ragstone pierced by narrow mullioned windows, the rooms darkened by wooden balustrades, benches, and tables rendered the colour of treacle through many decades of varnish. The loveliness of the place remained with Larry: ‘From this static harmony he drew some intimate recognition of beauty, some taste that "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("seemed parent to the taste of cold wind and sheer unhampered distance which had governed his child-mind.’ Not that the students were encouraged to look: most of the classroom windows were set near the ceiling to deny the students the distraction of gazing out during what Larry would call ‘the horrible lessons.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn35",
      "id": "ich02fn35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("35")])]), _vm._v(" A quiet country road led a mile and a half downhill into Canterbury. The austere main school building stood amid green lawns and playing fields on St Thomas’s Hill with the cathedral massively visible below in the centre of the town. Becket’s Canterbury might as well have been in the next county so far as the St Edmund’s boys were concerned: they were rarely allowed to walk into the town, and then only for a specific reason, in their best clothes and carrying passes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry was shown to his space in the long dormitory close under the slate roof, the dark beams making a geometric pattern overhead. Small dormer windows afforded views of Canterbury across the rolling downs. Along either side of the room stood a row of narrow beds, heads under the sloping eaves, feet towards the centre walkway, which was split by a rank of individual washstands without running water. By the head of each bed was a small chest of drawers. Larry dreaded the winter nights: ‘The windows had to be kept open, so that often the snow was blowing in on to your bed.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn36",
      "id": "ich02fn36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("36")])]), _vm._v(" Some mornings Larry had to break a pane of ice covering his basin for the obligatory face-neck-and-ears ablution. There were other discomforts, including ‘the icy plunge into the swimming-bath at seven sharp every morning.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn37",
      "id": "ich02fn37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("37")])]), _vm._v(" ‘It was really quite a tough business,’ Larry would remember. ‘But you were in a much better state of health because of it. The only thing was that you had a running nose the whole time from the cold; you know, like a dog.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn38",
      "id": "ich02fn38",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("38")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tumo")]), _vm._v(", the Tibetan Buddhist method for defeating the cold through a meditative state, came to Larry’s rescue, or so he would claim."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn39",
      "id": "ich02fn39",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("St Edmund’s academic syllabus was rigorous, and slanted towards the humanities. The headmaster, the Reverend Canon Walter Fletcher Burnside, projected his own passionate love for the Classics on to the curriculum. Of the twelve masters, four—counting the Head—were classics, two Junior School, and one each drawing, maths, modern languages, music and science. The remaining master had combined maths and science responsibilities. ‘Divinity, Latin, English, French, Mathematics and Science are taught throughout the school,’ proclaimed the St Edmund’s brochure of Larry’s time. The order in which the subjects were listed was significant, given Canon Burnside’s proclivities. From the fourth form on, ‘extra French, Maths and English are alternative with Greek.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn40",
      "id": "ich02fn40",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("40")])]), _vm._v(" Larry opted for Greek during his last term at the school. There were four classes each "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("morning, six mornings a week, and Burnside himself taught classics during all but one of these periods. Some idea of the level of the science instruction can be guessed from the fact that in 1922, after physics and chemistry had been part of the curriculum for fifteen years, A. D. McDonald, the newly appointed science master, discovered that the total laboratory equipment for chemistry consisted of a single flask and some lengths of glass tubing. When McDonald applied to Burnside for funds to rectify this staggering deficiency in equipment, he was given £10 and told to make do. Not surprisingly, most of the boys admitted to the universities from St Edmund’s qualified in classics rather than the sciences. Larry often spoke of his inability to handle technical subjects in qualifying examinations, and part of the reason—assuming that Larry ever attempted university entry-level examinations—probably had a lot to do with the low priority given to the subjects at St Edmund’s.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("The tyranny of prefects and housemasters, the seemingly pointless classes, the victimizing of the studious ‘swots’ by the ‘hairy ones’—the playing-field bullies—weighed upon Larry. He was probably writing autobiographically when he had Walsh Clifton find his first experience of a boarding school ‘bewildering’ and ‘unspeakably horrible.’ Larry described his fictional double as ‘a child of space, and that is as true an approximation of his qualities as words can give; lustiness, an aptitude for sheer sensual appreciation, a secret self-immolating zest for raw life’—all threatened by the dour outlook of the school.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn41",
      "id": "ich02fn41",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("41")])]), _vm._v(" Housemasters who were all smiles for visiting parents could swing the chastising cane with, it seemed to him, self-righteous satisfaction. Like Walsh in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" before his English schooling, Larry had never been beaten, and he reacted with blind rage when his turn came. His uncowed zest for life was remembered by an older schoolfellow, the Right Reverend Headley Sparks, who described him as having been ‘something of a pickle.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn42",
      "id": "ich02fn42",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("42")])]), _vm._v(" At the end of his first term he ranked fourteenth out of sixteen in ‘General Order’—which included conduct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry still seems to have sent ‘lying letters’ home, ‘in which he advertised his life as an ideal one, and himself as rapturously happy.’ In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" Larry was to write editorially, ‘Displays of this kind are common to us all’, and they were motivated in part by ‘warm pity for his well-meaning father who was so remote from the actualities of this new life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn43",
      "id": "ich02fn43",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("43")])]), _vm._v(" Whatever happened, he was determined not to let his father down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Letters from India in turn probably followed the tenor of those Larry ascribed to Walsh’s father in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper:")]), _vm._v(" ‘Your reports haven’t been too "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("good. However, old man, I feel I can always trust you to do the right thing and be a decent chap.’ And the impact of these letters on young Larry also must have matched those attributed to Walsh: ‘In the few closing phrases had been summed up all those things for which he was beginning to feel nothing but a bitter contempt—the awful ignorance of the Empire Builder, the would-be altruist, the dreary stupidity of the “team spirit”.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn44",
      "id": "ich02fn44",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("44")])]), _vm._v(" The idea of becoming part of the team of Empire was now repugnant, yet England was not providing him with a new set of aspirations and beliefs. Estranged from both India and England, he felt more lonely than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("St Edmund’s consisted of 160 boys divided into four houses, each under a master and a monitor. The shared classes, the sufferings and the general lack of privacy made for easy intimacy: ‘I made good friends,’ Larry would claim in middle life,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn45",
      "id": "ich02fn45",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("45")])]), _vm._v(" but these attachments do not appear to have long survived his departure from the school, and he would describe his fictional double Walsh as a loner at school: despite the ‘rough and ready fellowship’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn46",
      "id": "ich02fn46",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("46")])]), _vm._v(" that tempered his loneliness somewhat, ‘He could not claim one really close friend.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn47",
      "id": "ich02fn47",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("47")])]), _vm._v(" A digressive episode in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" suggests that Larry’s awakening sexuality may have brought him into contact with ‘a small clique’ given to ‘curious ways’ and ‘appetites’—those boys who secretly resisted the headmaster’s standard lecture against ‘smut.’ Rather defensively, Larry prefaced this account with the editorial assertion that ‘the boy is a dirty little animal, not a eunuch nor an angel’, and he has Walsh conclude, ‘It was purely and simply a sort of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("experimental")]), _vm._v(" attitude—like tasting a new drink. I didn’t like it, that’s all.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn48",
      "id": "ich02fn48",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("48")])]), _vm._v(" Perhaps Durrell felt that this was as close as he could then come to hinting at group masturbation or adolescent homosexual behaviour, whether or not either applied to him in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canon Burnside had been headmaster since 1908 and he maintained, in speech and in writing, that he and his staff existed to do their duty towards the school ‘regardless of anything else.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn49",
      "id": "ich02fn49",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("49")])]), _vm._v(" Burnside had handsome, direct eyes set wide over a full, even generous, mouth that seemed always on the verge of a smile. He had a face that promised both kindness and unflinching sternness. Certainly he was capable of both. He disapproved of smoking in public but enjoyed cigarettes. He feared the ‘Trade Union spirit’ that he thought stood in the way of the kind of service he expected from others; and he dreaded a future in which ‘religious teaching should not be the basis of the whole of the education of this country.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn50",
      "id": "ich02fn50",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("50")])]), _vm._v(" This was the man who had charge of Larry’s education during one of the most rebellious periods of his adolescence, and he would write a searing caricature of Burnside as ‘the immaculate one’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Larry benefited, however, from the conscientious teaching that Canon Burnside demanded. ‘The masters, like the Jesuits, were honest and lively and most competent,’ Larry would recall, stressing their honesty outside matters of religion. ‘My French master for example on learning that I wanted to learn French and become a writer immediately took a subscription to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Monde")]), _vm._v(" for me—the weekly literary pages …. This kindly and delightful man was mad about France and French literature and encouraged my interest. His name was Mr. Hollingsworth … he taught me my first words of the language.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn51",
      "id": "ich02fn51",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("51")])]), _vm._v(" Larry’s memory failed him—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Monde")]), _vm._v(" did not commence publication until 1944—yet he did rise from 13th out of 16 in French to first place in his form. He also studied the piano, and made the Pass List on the instrument.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry hated the religiosity of the school. Burnside must have seemed an agent of Big Granny, calling down Granny’s God on the heads of the young sinners bowing their pale faces in the chapel, yet paradoxically and perhaps hypocritically—to Larry—allowing tantalizing glimpses of the wonderful pagan world of the ancient Mediterranean. ‘I realized that I was in the middle of a lot of liars, and self-righteous like hell,’ Larry would say later, his voice taking on a cutting edge."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn52",
      "id": "ich02fn52",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("52")])]), _vm._v(" He reacted with ‘a morbid reluctance to attend chapel’ and a yearning for exuberant paganism."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn53",
      "id": "ich02fn53",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("53")])]), _vm._v(" ‘I saw through what I could see around me—in the Christian thing.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn54",
      "id": "ich02fn54",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("54")])]), _vm._v(" The twice-daily chapel services probably inspired his description of the ‘ordeals’ suffered by Walsh Clifton, with ‘the organ groaning loudly above the uproar in lachrymose anguish … groaning and invoking "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Granny’s God")]), _vm._v(" …. Meantime he must try not to listen: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he must not listen")]), _vm._v(".’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn55",
      "id": "ich02fn55",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("55")])]), _vm._v(" In the classical world so adored by that good Christian, Canon Burnside, Larry found an appealing antidote to Granny’s God: he responded with ‘the erection (in private) of altars to Apollo, Aphrodite, or another [god].’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn56",
      "id": "ich02fn56",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between the influences of Big Granny and St Edmund’s, Larry was cured of formal Christianity for good. In 1935, accusing his Quaker friend Alan Thomas of ‘pussy-footing it with the anglican jesus’, Larry struck out at Jehovah: ‘As for me, I think, JAH will always be a Ya! of derision.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn57",
      "id": "ich02fn57",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("57")])]), _vm._v(" Many years later still, when he was asked whether he believed in God, Larry replied, echoing Voltaire, ‘Of course I do—but in every kind of God. It is religion I don’t believe in.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn58",
      "id": "ich02fn58",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("58")])]), _vm._v(" Larry was developing this view at St Edmund’s, and by the time he left he was already becoming interested in Buddhism, but not as a ritual of incense and chants: ‘It’s after all a philosophy, not a religion in the other sense.’ Larry had never really felt himself a Christian in any case: ‘I didn’t have a nervous breakdown or anything, I didn’t have a "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("change of faith.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn59",
      "id": "ich02fn59",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("59")])]), _vm._v(" None the less, schoolboy Larry desired to please both his parents and Canon Burnside, and on 3 December 1926 the young sinner endured confirmation by the Archbishop of Canterbury in the great cathedral. He was fascinated by the place, the mediaeval darkness, the ancient martyrdom of Thomas Becket. Doubtless the solemnity of the present occasion also impressed him, but religious acceptance did not penetrate his sceptical hide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not only Christianity that young Larry turned away from: he learned to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("put up with")]), _vm._v(", not to accept, Pudding Island. Larry wrote of Walsh’s early experience of England, ‘But far above everything else it was teaching him to put up with the life of a narrow, ignorant, and conservative society in which practically none of the rules (unwritten) and regulations (printed) were not wholly idiotic.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn60",
      "id": "ich02fn60",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("60")])]), _vm._v(" Like Walsh, Larry was not becoming truly English: ‘You’re not a damned Englander yet,’ Walsh is told. ‘They haven’t got you yet.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn61",
      "id": "ich02fn61",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("61")])]), _vm._v(" Clearly, Larry was also speaking for himself. His housemaster tried to convince him to study hard and to excel at games so as to reflect credit on the house. Larry played football and ‘got all [his] house colours’, he claimed,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn62",
      "id": "ich02fn62",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("62")])]), _vm._v(" but he was not good enough in any sport to receive school colours."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn63",
      "id": "ich02fn63",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("63")])]), _vm._v(" He was, however, an apt pupil for the boxing lessons offered by the physical training instructor, and fought for his form in the ring with ‘huge ferocity.’ Gradually he lost the child-plumpness that had marked him in India and, although still short for his years, became lean and hard-bodied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of his first term, Larry was ranked near the bottom of his form in every area but the Division of History and English, and even there he was only 10th out of 16. However, he became popular with some of the masters and he was trusted to help reproduce examination papers on the mimeograph, ‘on parole not to look at the texts.’ The temptation was too great: ‘Needless to say … I was a clever lad,’ he admitted"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn64",
      "id": "ich02fn64",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("64")])]), _vm._v("—although whether his opportunities had anything to do with the later improvement in his marks, he never revealed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s studies during his rather haphazard schooling cannot be measured by curricula and school terms. For one thing, he always claimed to be unable to pursue a subject that did not interest him. Larry would have Walsh Clifton say to a scolding housemaster: ‘It’s not a question of working. It’s just that I cannot do anything that doesn’t interest me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn65",
      "id": "ich02fn65",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("65")])]), _vm._v(" Larry was really educating himself, and he evolved his own techniques. He ‘developed the deplorable habit of underlining those sentences in books which stated views with which he agreed.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn66",
      "id": "ich02fn66",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("66")])]), _vm._v(" He also kept a volume of aphorisms, a black notebook in which he jotted down cryptic notes and "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("copied passages, sometimes cutting out paragraphs and pictures from magazines, and even books, and pasting them in. This practice he would continue throughout his life.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s parents did not come to England during 1927, and he attended St Edmund’s during the summer term. A seaside visit, possibly with his aunt, Muriel Pearce, buoyed his spirits considerably, and would furnish an important episode in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(". If the fictional parallel holds, Larry met a girl at the beach, fell in love, and parted from her: but there is no direct evidence. In his recreating (or imagining) the embrace, Larry would attempt, parenthetically and in italics, to catch the mindless surrender of a first love:")])]), _c('p', {
    staticClass: "noindentf"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you shut your eyes and allowed your lulled senses to swirl you forward until you hung limp against her warmth, limp against her body like a swallow on a wall… It was as if you were being gently chloroformed … It was as if you grew slowly into her, that essential her … grafting your body on to her … merging your sense and will voluptuously into her … until her breasts seemed to grow into you, firm and piercing")]), _vm._v("….")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn67",
      "id": "ich02fn67",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The male "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passivity")]), _vm._v(" is noteworthy, the swooning unto death of a man who desires to give himself up to woman: here I am, take me, cherish me! The childlike dependent clinging to the woman, significantly without sexual consummation, suggests Larry’s loneliness and insecurity, both as an adolescent and when he came to write these lines, at the age of twenty-two. Images of heartbreak and loss would dominate Larry’s earliest extant poetry, as in ‘Sonnet Astray’, published when he was nineteen but possibly written as many as three years earlier:")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }, [_vm._v("And I,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Bewilderingly wonder at my great foolishness")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("To leave you forever alone that night by a star swept sea,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("With the laughter of the dark surf in your eyes …"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn68",
      "id": "ich02fn68",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is quite likely that both the novel and the poem reflected the same event.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A calendar year and one school term made up all his experience of St Edmund’s, and at the end of the autumn term in December 1927 Larry left school. He had not failed his exams, nor was he expelled for disciplinary reasons. He had not distinguished himself, but he had completed a year in the Cadet Force, he had advanced in the Fourth Form from Grade B to Grade A, and his performance had improved considerably: in English and History he had climbed to second out of eighteen. In General Science and "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Greek he stood second among eight. Only in Maths was he still near the bottom. Clearly, his attitude towards the school had improved, for in General Order he now held second place out of eighteen.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("His official record concludes, ‘Went to Wratting Park: for Coaching.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn69",
      "id": "ich02fn69",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("69")])]), _vm._v(" Like his father at Roorkee, Larry did not end up with a single academic, athletic or other kind of award noted after his name. ‘My father’s obsession was to get me to a university, you see, and I wasn’t going fast enough,’ Larry recalled; ‘I had faulted on the age thing, and I was way behind in my studies.’ Partly it was the class code—the move up to the ‘officer and gentleman’ social level to which Lawrence Samuel aspired—but, as Larry knew, ‘It wasn’t just simply a snob thing; it was also tied up with job hunting.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn70",
      "id": "ich02fn70",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("70")])]), _vm._v(" A degree from Cambridge or Oxford would open many doors. These considerations seemed too abstract, and too far in the future. He was bored with most of his classes, so Larry made no objection when his parents resolved to take him out of St Edmund’s; in fact, leaving school may have been his own idea. He was certainly impatient to get on with his life.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In later years, Larry was to recall almost exclusively good things about his instructors at his three main schools, St Joseph’s, St Olave’s and St Saviour’s, and St Edmund’s—a fine gallery of saints—crediting each institution, to various interrogators, with instilling in him a love of literature. It was also part of his interviewing personality to speak well of others; that is, when he was not riding a hobby-horse such as the horrors of Pudding Island. When he was lashing out at schooling in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", all the masters with one exception, the man who encourages Walsh’s reading, are portrayed as bloodless hypocrites, as ineffectual plodders and petty tyrants blind to the true purposes of education. Larry certainly possessed, from a very early age, an extraordinary ability to get along with people when he wanted to: it was part of his response to the terror of finding himself, a youngster away from home, at the mercy of others. Like many abused children—although Larry seems never to have been abused in any serious physical sense—he placated his tormentors. Whatever his real opinions of his schoolmasters, it is clear that they had not failed him except in maths. Certainly, when he left St Edmund’s he possessed an ingrained habit of wide reading and careful notation, a grasp of English literature and history, a love of classical Greece, a grounding in French, an indifferent knowledge of Latin and less Greek: these would serve him well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("After St Edmund’s, Larry was placed with various professional crammers in an attempt to bring him up to standard in the subjects he would face in university entrance examinations. In early 1928 he was sent to board at West Wratting near Cambridge, apparently with a tutor. Nothing came of it.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("A university education was not to young Larry’s liking—not, at least, the concentrated study needed to get into and through a university. ‘Neither my brother [Gerald] nor I could ever pass an examination,’ he would often remark, ignoring Leslie’s existence.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn71",
      "id": "ich02fn71",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("71")])]), _vm._v(" Larry could never let the matter drop, however. He liked to analyse his declared inability to get into a university. ‘At seventeen or eighteen, I was anti-everything,’ he would recall. Then he would add modestly:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("And yet I should have liked to have gone to Oxford, if only to give my father some pleasure. Intellectually I was brilliant, but like all Irishmen I was dreadfully lazy. And above all my subconscious was set on proving to my father… that it was unfair to send me back to prison. So in spite of my capabilities I fluffed all the exams; three, four, five times …. Of course I hadn’t read Freud at the time, or had anything to do with psychiatrists as I do now; it was a natural complex: I deliberately failed the exams, because of a subconscious resentment, in order to prove that the initial decision was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As the university prospect faded, Larry’s commitment to writing grew: ‘It was then that I decided to write,’ he claimed. ‘Before long I had joined the world of London bums.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn72",
      "id": "ich02fn72",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("72")])]), _vm._v(" How far Larry believed his own account is debatable, and he contradicted himself freely: although he would repeat his claim about failing entrance examinations, he would date his decision to write seriously anywhere from his pre-teens to the publication of his first novel in 1935.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During his school years and tutorial period there were a couple of holiday trips across the Channel for Larry, and on one occasion he thrilled to the beauty of Lausanne and Vevey, stopping in Paris on his return. He identified as his poetic initiation a copy of Philippe Soupaul’s study of Lautréamont, which he picked up by chance on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quais")]), _vm._v(" and read beside the Seine."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn73",
      "id": "ich02fn73",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("73")])]), _vm._v(" When his French would not suffice he turned to Richard Aldington’s essays and translations of French poetry and fiction."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn74",
      "id": "ich02fn74",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("74")])]), _vm._v(" These short excursions, free from official oversight and free from the social codes governing the behaviour of youth in England, confirmed Larry’s early instinct that in escape from Pudding Island lay his main chance of joy and even of survival. He was also learning to escape into verse: by the time of "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("his sixteenth birthday, he had begun seriously to write. ‘I suspect it was an enjoyment of my own privacy,’ he would recall many years later. ‘If you’re very lonely, it’s very useful to write poetry. It keeps you company, like a pet parrot.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn75",
      "id": "ich02fn75",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early in 1928, far away in Lahore, Larry’s father developed severe headaches and started to act irrationally: ‘He began to drink the ink instead of the whisky,’ Larry was told."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn76",
      "id": "ich02fn76",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("76")])]), _vm._v(" Hoping that a period of rest in a cool climate would set him to rights, the family went to Dalhousie, an Indian hill station near the present border with Pakistan. It was only a short day’s journey by motor car for the Durrells. The road climbed steadily in a long series of switchbacks after Pathankot, and soon they were among the pines and cedars above 6,000 feet. Dalhousie existed mainly as a health resort, with a climate so cool that tea would not grow on the nearby slopes. Snow and hail were fairly common in February and March, and huge sacred langurs with magnificent grizzled pelts lounged about the town in the red tree rhododendrons, chewing reflectively on the blossoms. The Durrells rented a two-storey house off a small road junction called Charing Cross, one of the two main circuses of Dalhousie, and moved in with chauffeur, governess, ayah and bearers. The street name seemed to mock Lawrence Samuel’s hopes for England. He realized his need of help, and his proud nature had become ‘very amenable’ at times. He could still walk, yet ‘you couldn’t trust him’, his daughter remembered."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn77",
      "id": "ich02fn77",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("77")])]), _vm._v(" Terrifying his family, he fought against his headaches and loss of control, but eventually he had to be admitted to the tiny English Cottage Hospital on the edge of a ridge facing the Himalayas. Louisa moved with him into the hospital. Leslie, Margaret and three-year-old Gerald stayed in the house with their Irish governess, who walked them along every day in melancholy procession to visit their parents, stopping coming and going at St Mary’s Church. Margaret recalled that, as the governess ‘was an ardent Catholic, we did a mighty lot of praying.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn78",
      "id": "ich02fn78",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("78")])]), _vm._v(" She had a stock of religious pictures and bottles of holy water from Lourdes, and she told the children that if anything happened on the road, they were to run for the priest, not the police or the doctor."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn79",
      "id": "ich02fn79",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither the relatively primitive medicine practised in Dalhousie nor the prayers proved efficacious. Lawrence Samuel Durrell died during a violent storm on 16 April, six days after entering the hospital. His malady was described by the family as ‘a tumour on the brain’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn80",
      "id": "ich02fn80",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("80")])]), _vm._v(", and the Dalhousie official register named as the immediate cause of death a cerebral haemorrhage. He was only forty-three years old. Larry was informed by "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("cable. A brief service was held in the small slate-roofed Anglican church in Dalhousie, mossy under the cedars, and a burial party of soldiers took Lawrence Samuel to the English cemetery,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn81",
      "id": "ich02fn81",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("81")])]), _vm._v(" on an evergreen-covered hillside sloping steeply down towards the Punjab, the vast theatre of his railway-building and engineering efforts. His children were not permitted to attend the funeral. The minister, the Reverend Pryce-Jones, seemed to Louisa cold and supercilious. It was the nuns at St Mary’s Convent who consoled the shattered widow, and so warmly that Louisa nearly turned Roman Catholic in the days following."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn82",
      "id": "ich02fn82",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Larry Durrell’s lifelong reticence about speaking of his father suggests that his response to his death may have resembled Walsh’s under similar circumstances in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers:")]), _vm._v(" ‘He felt guilty and ill at ease under the bland expressions of condolence—guilty because he was capable of feeling nothing but his overwhelming dumbness.’ Larry’s various partings from his parents, coupled with the schoolboy code that demanded the concealment of suffering, whether physical or emotional, had taught him to avoid any public display of his emotions. Now, with his father’s death, he was expected to show grief, but he found himself turned to stone, ‘heavy and dull’, unable to weep."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn83",
      "id": "ich02fn83",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The shock none the less hit Larry hard. So much of what he had done in England had been conditioned by the presumed approval or disapproval of his father that Larry felt suddenly rudderless. He had very much wanted to please his father, even while he was bent upon proving that it had been wrong to send him to England. The disappearance of Lawrence Samuel in his guise as a figure of utter moral rectitude cast Larry adrift. Gradually Larry came to understand how much of what he had done, in England as in India, had been tempered by considerations such as ‘Dad would be pleased’, or ‘He wouldn’t like this.’ Suddenly Larry realized that there was no one whose approval or censure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" mattered: he was free, yes, but he felt the burden of his responsibility for himself crash down upon him. Despairing and empty and lonely, ‘for want of company’ Larry apparently attempted to find solace with ‘one of the salvarsan cuties’, he would later confess."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn84",
      "id": "ich02fn84",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("84")])]), _vm._v(" The episode found its way into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers:")]), _vm._v(" Walsh, lonely and sad after the death of his father, ‘took a bus to the nearest town; for the first and the last time in his life he went with a woman’, a paid one."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn85",
      "id": "ich02fn85",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This banal liaison may have been Larry’s sexual initiation. Often in the future, when faced with a crisis, he would seek comfort and release in sensuality, would ‘get carried off in sex, the ambulance’, as he was to write "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("later in a poem. His sexual precocity, however, did not appear to be evidence of emotional maturity. Rather, cut off from his mother and from other older women to whom he might have confided his distress, he had thrown himself on the mercy of the first female who would hold and caress him. It marked the beginning of a pattern. Richard Pine, in his monograph on Durrell’s ‘Mindscape’, identifies the two poles of Larry’s quest as being ‘sexual curiosity’ and ‘metaphysical speculation’: the former, as defined by Freud, being irrevocably linked with the quest for knowledge, the second a main feature of Aldous Huxley’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Point Counter Point")]), _vm._v(",")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn86",
      "id": "ich02fn86",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("86")])]), _vm._v(" which appeared the year of Lawrence Samuel’s death, and which was much discussed in Larry’s London circle shortly after he left St Edmund’s. Here, in the first great impact of death upon Larry, the sexual and the speculative impulses came together for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The effect of Lawrence Samuel’s death on the entire family was immediate and profound: within two months Louisa left India, never to return, and from then on devoted herself entirely to her offspring. The old tension between husband and livelihood in India, children at school in the Home Country—the lot of most colonial wives with families—ended with Louisa’s move to London. The Alleyn Park Road house in Dulwich required a large and expensive staff, so Louisa evidently renewed an older lease to her brother-in-law Harry Rickwood."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn87",
      "id": "ich02fn87",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("87")])]), _vm._v(" Then she purchased a service flat in the Queens Hotel in Upper Norwood just south of Dulwich. The Browns, a matriarchal clan consisting of Grandmother Richardson, her daughter Mrs. Brown, and two granddaughters, were Louisa’s only good friends in England, and they already lived in the hotel. One of the girls, Dorothy, became Margaret’s particular friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without the stern authority of her husband behind her, the mild and unassertive Louisa could not control her strongly independent children. Leslie was a terror, Margaret was showing the unconventional, headstrong Durrell nature, and even little Gerald, only three years old, was already horrifying his mother by bringing into the house every insect and animal he could catch. Larry was still grappling with the implications of his father’s death when he was writing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" six years later, and in the novel he analyses the impact on a family of the loss of a dominant husband: ‘He had harnessed and directed [the wife’s] energies with the gentleness of his own magnificent largeness and strength.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn88",
      "id": "ich02fn88",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("88")])]), _vm._v(" With Lawrence Samuel and the established social pattern of India bracing her, Louisa had been quite an effective parent and household manager, a woman secure in her place. All that changed after his death and her departure from India. Larry too missed "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("the stability that his father had represented: he was not ready to assume responsibility for himself, yet there was no one to shoulder that responsibility for him. If only he could be eleven again, back in India, with his father still presiding over his destiny! An eleven-year-old was not expected to behave responsibly at all times, and in crises during the rest of his life Larry would not infrequently lose himself in pre-adolescent behaviour, lashing out with tongue and, occasionally, fists.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("It was not finances that caused the Durrells to drop out of schools and give up the prospect of a university education. Lawrence Samuel’s Indian partners dealt honourably with the widow; Larry recalled his mother saying, ‘Thank goodness the Indian partners were so straight.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn89",
      "id": "ich02fn89",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("89")])]), _vm._v(" Although a depression in the construction industry in India had somewhat diminished the profits of Durrell & Co., there was enough money for school fees, a large house, a few servants, even a chauffeur. Stone, the chauffeur, referred to as ‘the family manservant’, worked on Larry’s boxing skills, sparring with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inheritances were to become an important theme in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", where, although they may have promised well, they always turned out to be disappointingly small. Walsh’s friend Gordon, speaking of his patrimony, says, ‘It was a lot when I first got it; but most of the securities were so rocky that they crumpled up.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn90",
      "id": "ich02fn90",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("90")])]), _vm._v(" In Louisa’s case, a portion of the wealth that Lawrence Samuel left was in Japanese gold shares, and these collapsed. Walsh, when his father dies in India, says, ‘I have an idea that when my father’s estate is cleared up there will not be much money—certainly I think not enough for me to return to school.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn91",
      "id": "ich02fn91",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("91")])]), _vm._v(" While this may not have been the case for Larry, within a few years the family’s circumstances had declined appreciably. Like most Victorian women, Louisa was totally unused to handling money in larger than household amounts: women were not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("expected")]), _vm._v(" to know anything about investments, interest and mortgages. Larry was to claim with some bitterness that his mother, ill-advised, had squandered a quite satisfactory competence. The squandering began at the hotel in Upper Norwood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Queens Hotel was in Church Road, near the old Crystal Palace, and it housed, apart from the Durrells, an assortment of odd characters, some of whom would appear but slightly disguised in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book")]), _vm._v(". Down the corridor was a dining room ‘like an aquarium’, full of retired people ‘out of work and on the shelf’, old colonels ‘a little bit soft in the head and chainsmoking and old ladies with irresistible giggles and dropped wombs.’ Larry did not confine himself to the Queens Hotel ‘geriatric scene’, as he called "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("it.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn92",
      "id": "ich02fn92",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("92")])]), _vm._v(" ‘This was when he was having his times with the negresses and all that,’ Larry’s first wife Nancy recalled disapprovingly."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn93",
      "id": "ich02fn93",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("93")])]), _vm._v(" The Queens Hotel would become the Hotel Regina in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book")]), _vm._v(", and Larry admitted that a couple of his caricatures in the book were ‘somewhat libellous—very, in fact.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn94",
      "id": "ich02fn94",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Larry was storing up events and character notes for his writing, his siblings and the two Brown girls terrorized the hotel: once they decorated the discreet, sentimental statuary in the main hallway and lobby with underwear; another time they rearranged the shoes left for polishing outside the room doors—ladies’ shoes in front of men’s rooms and vice versa. Mrs. Hocking, the proprietress, soon knew whose doors to knock upon whenever any outrage was discovered. ‘Now, dears, you really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mustn’t")]), _vm._v(" do such things. What will the neighbours think?’ Louisa kept telling her brood."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn95",
      "id": "ich02fn95",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry wandered disconsolately about Upper Norwood and Dulwich. Everything seemed grey: the buildings, the rain, the faces. The Crystal Palace, originally built for the Great Exhibition of 1851, ‘glittered’ with ‘grimy glass’ in the ‘sooty darkness’, and its towers were ‘two black phalloi.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn96",
      "id": "ich02fn96",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("96")])]), _vm._v(" Louisa went to the family solicitor for advice about Larry: place him with an Army crammer, the man said. The service will straighten the lad out, and he can make a career in the Indian Army! Soldiering had done well for his grandfather. However, India no longer looked so good to Larry—his roots had been dislodged—and going into the Army was ‘the last thing he wanted to do.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn97",
      "id": "ich02fn97",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("97")])]), _vm._v(" Consequently, Larry did badly with this tutor as well, but he made a friend among his fellow-victims, Cecil Jeffries, who like Larry had no intention of being crammed into the military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the summer of 1929 Larry was very much at a loose end: he had given up on the university, and he had refused to join the Army. He had learned to drive to some extent—enough to take Louisa’s car out and smash it rather badly, as an angry Uncle Cecil Buck discovered when he came in December to borrow the car."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn98",
      "id": "ich02fn98",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("98")])]), _vm._v(" In 1930 Larry managed a trip to Amsterdam where he ‘felt the benediction of rebirth’, as he wrote in his poem ‘Happy Vagabond.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn99",
      "id": "ich02fn99",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("99")])]), _vm._v(" Larry’s antics and strange acquaintances became a bit much, even for the tolerant Louisa: ‘You can be as Bohemian as you like’, she told him, ‘but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not in the house")]), _vm._v(".’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn100",
      "id": "ich02fn100",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("100")])]), _vm._v(" ‘I only feel that I am losing something by not being understood,’ Larry would write when his fictional counterpart Walsh departed the family home in similar circumstances."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn101",
      "id": "ich02fn101",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("101")])]), _vm._v(" All his life Larry would be haunted by the conviction that neither in his writing nor in his person was he properly understood. Louisa, baffled, again asked the family "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("solicitor for advice. He happened to have a friend who was an estate agent in Leytonstone, east London: young Durrell could work there as an unarticled trainee. Larry could see a glimmer of advantage: this would give a colouring of mundane purpose to his move to London. His mother agreed to give him a weekly allowance. Packing a guitar with the rest of his kit, Larry escaped towards the heart of the great city.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He knew he did not want to live in Leytonstone, a dull, middle-class area that could almost have been Upper Norwood. He found rooms off Charlotte Street in Bloomsbury—most promisingly, he thought, in a house where Verlaine was reputed to have lived. Not far away, at 5 Old Compton Street, Verlaine and Rimbaud had drunk absinthe. Leytonstone was a world away: some days a reluctant Larry inspected-property and dunned tenants for back rent. Dogs strained to get at him, people slammed doors in his face, and he learned what it meant to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distrain chattels")]), _vm._v(". Leytonstone Road intersected with Henniker Street—the name Larry was to give forty years later to an elderly brothel-keeper in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revolt of Aphrodite")]), _vm._v(". His desultory work around Leytonstone was a stage in his own revolt.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("Although Larry at various times smoothed over his early life in England—St Edmund’s was beautiful, the masters were kindly, he was treated with understanding—the sum total of his memories and remarks adds up to a negative: ‘Then that mean, shabby little island up there wrung my guts out of me and tried to destroy anything singular and unique in me,’ he once stated.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn102",
      "id": "ich02fn102",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("102")])]), _vm._v(" The whole ambience was wrong: ‘I very much hoped that England was going to be Surtees’ England—a vulgar, jolly, roistering England, not especially aesthetic or cultivated or delicate in any sense, but something with its vulgar roots in food, sex, and good living.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn103",
      "id": "ich02fn103",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("103")])]), _vm._v(" He certainly did not find the England of Surtees’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jorrocks’s Jaunts and Jollities, Handley")]), _vm._v(" Cross and Mr. Soapey Sponge. However, Master Durrell the schoolboy, Lawrence G. Durrell the failed candidate for a university education, was struggling to become Larry Durrell: Larry to his friends, Durrell to the literary world. Durrell the writer would eventually come to terms with England; Larry never would.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Larry became friendly with his second cousin, the novelist Richard Sidney Blaker, who was earning a modest popular recognition. Blaker had an uncle living in Upper Norwood, and the family was on visiting terms with the Durrells and the Bucks. Larry liked Blaker’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scabby Dichson")]), _vm._v(", and his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Medal Without Bar")]), _vm._v(", which appeared in 1930, was ranked by some as being among the best novels to have emerged from the First World War. "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("While Blaker had not exactly lit up the literary skies, his friend the writer Louis Golding said that ‘his sense of people ranks him with Arnold Bennett and [his] sense of things is as consummate as Rudyard Kipling’s.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn104",
      "id": "ich02fn104",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("104")])]), _vm._v(" Blaker was born in 1893 in India, and had inhaled mustard gas on the Western Front. His health had never fully recovered, but he had received his MA in Classics at Queen’s College, Oxford. He was a handsome man with thin, curving lips, a long arched nose, wavy hair and an air of quizzical detachment. Here was someone for Larry to emulate, and in fact Blaker gave him his first real encouragement towards authorship."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn105",
      "id": "ich02fn105",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("105")])]), _vm._v(" India, a touch of Kipling, and Oxford seemed to add up to success in writing. Larry felt that he had two parts of the equation in hand, and he was sure he could finesse the third if he would only throw himself into the task. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scabby Dichson")]), _vm._v(", with its many echoes of Kipling, would provide Larry with suggestions for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(". In both novels a half-orphaned boy attends an Indian boarding school and is self-consciously alone, superior and proud; a character named Turnbull is also a friend and mentor to the hero in each book. Scabby Dichson’s mother is eventually found hanging from a punkah-rope in a seedy neighbourhood of Lahore: the image of a hanged woman would spring up in Larry’s last major fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blaker was considerate and kind, even to the point of letting Larry use his vacation caravan near Cadnam in the New Forest, for ‘a couple of tough winters in Robin Hood like circs’, Larry would recall: ‘No girls alas.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn106",
      "id": "ich02fn106",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("106")])]), _vm._v(" Perhaps Larry found his cousin too elegant, too genteel, his writing too ironically detached. At any rate, the personal connection did not long continue, and Blaker would be dead by 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, Larry kept up his friendship with Cecil Jeffries, who had acquired a small press. Within a year, in 1931, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quaint Fragment: Poems Written between the Ages of Sixteen and Nineteen")]), _vm._v(" was printed by Jeffries, who had asked Larry for something to practise on. The subject matter of the seventeen poems tends towards past passions, loss and death, the tone towards sweet melancholy: whiffs of precocious decadence, but without the bite of Rimbaud. In ‘A Dedication’ Larry announced the poems to be ‘lame and halting parodies / Of greater, better poems.’ However, he demonstrated a fine ear for the cadences of English: ‘There is a great heart-break in an evening sea’, he began one poem."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn107",
      "id": "ich02fn107",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("107")])]), _vm._v(" This rarest of Durrell’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incunabula—")]), _vm._v("only a few are known to have survived—had a very limited print run, and the London bookseller Joseph A. Allen, who co-operated with Jeffries on the venture, thought that fewer than a dozen copies had been printed before the type was dispersed."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn108",
      "id": "ich02fn108",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("When the Browns moved to Bournemouth in March 1930, Louisa Durrell decided to follow them. ‘Somebody told her the sun shone here more than anywhere else in England, and as we always seem to chase the sun …’ recalled Margaret, leaving her sentence unfinished.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn109",
      "id": "ich02fn109",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("109")])]), _vm._v(" Louisa bought Berridge House, an imposing place in Parkstone, next to Bourne-mouth, and in 1932 she sold the Alleyn Park residence. In fact, Louisa’s children accused their distracted mother of believing that she had bought in Bournemouth itself. Larry’s anger at estate agents was reflected in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", in which ‘a bland and accomplished ruffian’ hoodwinks Aunt Brenda into a foolish purchase."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn110",
      "id": "ich02fn110",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("110")])]), _vm._v(" True to form, Louisa Durrell bought above her needs and beyond her means. It became an adage with her that ‘when people find out it’s only a woman they have to deal with they take advantage.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn111",
      "id": "ich02fn111",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("111")])]), _vm._v(" The house was a rambling three-storey building set close to the road but with a large back garden sloping downhill to a tennis court.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry did not move with the family, but dashed down from London for weekends and holidays, either borrowing his mother’s car or taking the train. He disliked Parkstone/Bournemouth from the first: it was another ‘geriatric ward’,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn112",
      "id": "ich02fn112",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("112")])]), _vm._v(" but he complained about the children as well. Larry’s young cousins Phyllis and Molly Rickwood learned to ride bicycles on the lawn, screaming with laughter when they fell. Larry, sitting in an upstairs room trying to write, would lean out of the window periodically to shout, ‘Stop that bloody row!’ The cousins remembered Gerald as a beautiful little boy, gentle and great fun. He had a secret hideout high in a tree, to which they dared not follow him, and he terrified them by playing with glow-worms, allowing the insects to crawl around his fingers. Margaret enjoyed Parkstone and was doing well in her studies at Malvern. Only Leslie seemed to be unable to get a grip on himself. He drove his mother mad by lounging in bed till noon and then slouching about; and he was moody and would sometimes turn on the younger children."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn113",
      "id": "ich02fn113",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("113")])]), _vm._v(" Only when there was a party did he show the warm, engaging side of his nature. Fortunately, almost anything could become an excuse for a party at Berridge House. Once someone decided to have a bonfire, and when the pile of brushwood was slow to light, Louisa said, ‘Leslie, there’s a bottle of spirits under the sink—fetch it, would you, dear?’ Leslie dashed out waving a bottle, and the flames rose with a whoosh. Only then did they discover that he had poured an entire bottle of whisky over the damp wood."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn114",
      "id": "ich02fn114",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For about a year there was a staff at Berridge House that included a butler, a housekeeper named Lottie, and one or two other servants; then "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("Louisa’s banker stepped in to inform her that she was living well beyond her income. The Great Depression that continued for years after the US stock market crash of 1929 was eating further into her capital. Berridge House was sold at a loss and Louisa bought again, a smaller but still very substantial dwelling set in a garden with tall evergreens and shrubs. She christened the new house at 18A Wimborne Road ‘Dixie Lodge’ and settled in, retaining the services of Lottie. Louisa was finally in Bournemouth, where she thought she wanted to be.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("By mid-1932, Larry had met a young woman who was attracted to him in part because she had seen him driving a large, dark maroon saloon car, his mother’s new Hillman. Nancy Isobel Myers, an art student at the Slade, was intrigued by this compact young man whose small stature and round face made him seem even younger than his twenty years, made him seem to need mothering. Larry played up his boyish looks by amusing Nancy with baby-talk: ‘I’se only ickle baby,’ he clowned.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn115",
      "id": "ich02fn115",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("115")])]), _vm._v(" It was not entirely joking on Larry’s part: a side of him still wanted the security of a woman who would look after him. Irrationally, he felt betrayed by his mother,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn116",
      "id": "ich02fn116",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("116")])]), _vm._v(" abandoned by Aunt Muriel. In Nancy he perceived an attractive young woman who also seemed very capable, poised, moving in her circle with verve and assurance. Nancy was a few months younger than Larry, five feet eight inches tall, slender, and wore her blonde hair in a modish bob. She dressed carefully and was so lovely that people turned to stare: Larry was smitten. Nancy was very conscious of the need to establish an identity: ‘You had to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shed")]), _vm._v(" your family and everything,’ she recalled. ‘You became an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("artist")]), _vm._v(" or you became something or other like that.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn117",
      "id": "ich02fn117",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("117")])]), _vm._v(" Larry was eager to help her shedding and becoming process—he was doing the same himself. When he attacked with repartee and laughter, probing her ideas and prejudices, she responded with passionate argument. Nancy’s family, more so than Larry’s, boasted a sufficiently formal and formidable respectability to need shedding, or so it seemed to the young artist. One grandfather and a great-uncle were reverend ministers, and her maternal great-grandfather, William Green, had been Governor of Durham Prison. The Greens were entitled to a coat-of-arms with ‘three stags trippant argent’ and they were proud of their somewhat ambivalent motto, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Semper Viridis")]), _vm._v("—Eternally Green. Financial reverses had left Nancy’s parents dependent on her father’s small provincial dental practice, and her grandfather had paid for her schooling at Lincoln High School.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy may have talked about casting off her family in order to find "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("herself as an artist, but her manner and accent were part of her being, a class badge. Although not really a snob, Nancy felt herself very much a lady and took herself seriously. Her father certainly did not take her art studies seriously, and he was horrified when she said that she might become an actress. Socially, the Durrells were down a peg or two. Louisa and Larry’s aunts and uncles were quite "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("proper")]), _vm._v(", but they were not quite "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it")]), _vm._v(". Larry was fully aware that they bore a colonial stigma: they wore funny hats, and in Anglo-Indian accents compared everything in England to India—usually to the detriment of England. He exploited their foibles for comic effect when he was with Nancy.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("Nancy and her friends prided themselves on their knowledge of advanced literature and read D. H. Lawrence and Aldous Huxley. She had been consorting with a nest of progressive Wykehamists in the Fitzrovia of Augustus John and Nina Hamnett. Nancy took Larry, her new acquaintance, in tow. Thus Larry met Peter Bull, not yet properly launched on his acting career; the Honourable Nicholas Phipps, a ‘sort of Noel Cowardish’ young man; and George Curwen Wilkinson. Bull was large and bulky—among his roles would be Pozzo in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waiting for Godot")]), _vm._v(" and ‘the boxing champion of the world’ in another play—but his heavy, brooding face masked a frolicking sense of humour and a tendency towards high-pitched, hysterical laughter. Fitzroy Square was considered arty, and a generation earlier Virginia Woolf had held her Thursday evening gatherings there, ‘where long-legged young men would sit in long basket-chairs smoking pipes and talking’, as Lady Ottoline Morrell had described the scene.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn118",
      "id": "ich02fn118",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Wilkinson had just the long legs to fit Mrs. Woolf’s Bloomsbury tableau, and he smoked a curved briar and cultivated a Strachey air. He felt the self-conscious intellectual superiority of a Winchester boy—his was a far more prestigious school than Larry’s St Edmund’s. A left-handed fencer, he had taken the bronze medal in the public school championships. Then George’s father had died, leaving him a small income on which he could barely subsist in London. His Curwen relatives on his mother’s side were prominent Cumberland folk and his great-grandfather had founded the Curwen Press. For a time during 1932 Larry moved into George’s bed-sitter at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("6")]), _vm._v(" Fitzroy Square, where he met Pamela Black, the young actress who was to become Mrs. Wilkinson two years later. Larry would write this scene into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers:")]), _vm._v(" Pam in a bathing costume cooking—and burning—the supper, George stretched at full length pontificating. Pam was small, pretty in a puckish way, with a quick laugh, and she wore her corn-golden hair in an Eton crop, shorn close at the back. Larry struck her as ‘a short "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("and good-looking man’ whose snub nose ‘made him look very young and cherub-like.’ She thought him a ‘brilliant talker’ and liked his ‘charm and enthusiasm.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn119",
      "id": "ich02fn119",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("119")])]), _vm._v(" Larry found Pam very attractive, and would give the character based on her in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" Nancy’s middle name, Isobel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In those early days Wilkinson took the lead and Larry, somewhat awed by his friend’s sophistication, danced attendance. George was very thin and very tall, had a pleasant face, spoke with sardonic humour, ‘like the driest of dry sherries’, and he peered at the world through tortoise-shell glasses."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn120",
      "id": "ich02fn120",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("120")])]), _vm._v(" He worked as secretary for A. J. A. Symons at The First Editions Club; he spoke in measured tones and twiddled a signet ring on his elegant finger. George had a neat, pointed brown beard that he liked to stroke downwards: ‘such a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pubic-looking")]), _vm._v(" affair’ Larry would term it."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn121",
      "id": "ich02fn121",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("121")])]), _vm._v(" On one occasion George stroked Nancy’s breast as a connoisseur might, ‘and then gave a sort of judgement like a wine-taster …. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Very")]), _vm._v(" nice”.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn122",
      "id": "ich02fn122",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("122")])]), _vm._v(" Sarcastically, Larry would say of Russell, the Wilkinson act-alike in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", ‘He … fancies himself as a seducer.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn123",
      "id": "ich02fn123",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George, Larry and Nancy frequented the Bloomsbury bookshop of Joseph Allen at 16 Grenville Street. The shop had been a post office and bore the caduceus of Hermes on either side of the door, so Allen named his small printing venture the Caduceus Press. Allen was a jaunty dresser, a short, stocky man with the self-confident stance of a boxer or a jockey. Only a few years older than Larry, he cast an interested eye on Nancy and decided she was a passionate number. Coolly, he speculated that sex and jealousy were behind the quarrels he witnessed early on between Nancy and Larry. Larry showed all the traditional signs of being in love with Nancy: he was, in rapid succession, tender, cruel, entertaining, boorish, courtly and possessive."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn124",
      "id": "ich02fn124",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("124")])]), _vm._v(" He was revolted by the easy sexuality of the young in Bloomsbury. Full-blooded lust was fine, but not the thin couplings of casual revellers. ‘Lust was something too fine-tempered, too supple, to be blunted and soiled by a mob of chattering starlings,’ of ‘thumb-sucking apes’, he would write."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn125",
      "id": "ich02fn125",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry took Nancy to Bournemouth to meet his family, but not before he had dramatized and exaggerated their deficiencies: his mother was ‘mad’, she drank and threw her money away; his brothers and sister were ‘ridiculous’ and ‘spoiled.’ Nancy was intrigued, never having heard anyone speak in quite this way about his family, but she immediately loved the entire household. It had an air of craziness that appealed: ‘It looked like people sort of playing at keeping house rather than really keeping house,’ she thought."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn126",
      "id": "ich02fn126",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("126")])]), _vm._v(" No one was forced into a mould; people could—and were "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("apt to—say anything. Leslie, Margaret and Larry introduced Nancy to bicycle polo and the concomitant risks of skinned knees and torn stockings. Gerald, then about seven, reminded her of Christopher Robin. He was enrolled in Wickwood School, but seldom went. His technique for avoiding lessons was to develop a ‘school pain’ every Monday morning,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn127",
      "id": "ich02fn127",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("127")])]), _vm._v(" and if that did not work, to cling screaming to the playground railings until his mother relented and took him home. For a time, he had a tutor at home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy’s visit ended in a terrific row with Louisa Durrell when Larry "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" Gerry jumped into bed with Nancy the first morning, and the luckless girl was accused of corrupting a mere child. Nancy and Larry were welcomed back a fortnight later by a cheerful Louisa who simply adopted Nancy, deciding that she was too thin and trying to fatten her with butter, cream and pastries, and finally inviting Nancy to join her sipping tea laced with gin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy had been absolutely broke and was staying in borrowed lodgings in Charlotte Street when she met Larry. Then she became part of the cast of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v(", a drama based on Christa Winsloe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Child Manuela: Mädchen in Uniform")]), _vm._v(", at a salary of thirty shillings a week. This allowed her to pay eighteen and sixpence weekly for bed and breakfast with a Mr. and Mrs. Lang. Larry at this time had two rooms off Charlotte Street on the Bertorelli or west side. Mr. Lang was a very proper gentleman—he had expelled his previous tenant, an impoverished Yorkshire Labour MP, for entertaining a lady in his room—and Nancy was nearly given the same treatment when Lang caught her ‘canoodling and kissing’ in the stairwell with Larry. Eventually Nancy left for a room in Calthorpe Street near Lamb’s Conduit Street. If these various lodgings had anything in common it was that they were drab, cheerless and under-furnished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy had met a cadaverous poet named John Gawsworth through a friend at the Slade, and she introduced Larry to him at the Windmill Café, where Larry usually waited in the evenings for her to emerge from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v(". Larry was impressed by Gawsworth, whom he was to label ‘my first Real Writer—a professional living by his books’, completely ignoring his more financially successful cousin Richard Blaker. Gawsworth was not living very well to be sure, but ‘inhabited an old attic’ with crumbling beams and a rotting floor up three flights at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("6")]), _vm._v(" Denmark Street. Percival Mackay’s jazz band rehearsed downstairs,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn128",
      "id": "ich02fn128",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("128")])]), _vm._v(" and a music publisher shared the building. Gawsworth took Larry and Nancy to his rooms where he displayed his treasures: his correspondence with de la Mare, Drinkwater and Wyndham Lewis; a skull-cap that had belonged to Dickens, a pen of "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Thackeray’s. Soon Larry was showing Gawsworth poems for criticism. Larry would walk over from his new flat at 106 Guilford Street near Russell Square. Gawsworth worked very hard indeed at being a literary gent. In fact, he even wrote under three sets of names, sometimes using his real name, Terence Ian Fytton-Armstrong, and at least once as Orpheus Scrannel. To Nancy he seemed ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incredibly")]), _vm._v(" Grub Street’: spiderlike in his dark chambers, he appeared emaciated, very white, with a long, thin face and a ‘very pointed nose, sharp little black eyes’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn129",
      "id": "ich02fn129",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("129")])]), _vm._v("—Larry said his eyes were ‘brown and bright.’ His broken nose, Larry thought, was not a disfigurement but ‘gave his face a touch of Villonesque foxiness.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn130",
      "id": "ich02fn130",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("130")])]), _vm._v(" From one corner of his mouth drooped a cigarette, and this he could slant up towards a simultaneously cocked eyebrow. During those early days his poverty did not prevent him from dressing with infallible neatness and keeping his shoes well shined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gawsworth, whose brother was the Jacobite Earl of Gawsworth, loved ceremony and valued the elegant gesture: even when almost penniless he would buy a large white rose on the anniversary of Charles I’s execution and place it reverently at the foot of the king’s statue in Whitehall. He was well aware that Nancy cut a striking figure and he liked to be seen with her at the Café Royal. On one occasion Larry and Gawsworth resolved to have a duel of words over her and orated most of the night while a bored Nancy drank tea and dozed. With the coming of daylight Gawsworth conceded defeat: ‘Lawrence, the best man has won, and may you take the fair lady.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn131",
      "id": "ich02fn131",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("131")])]), _vm._v(" Soon Larry and Nancy were sharing lodgings and funds. She encouraged him to give up entirely his estate agent apprenticeship, and Larry persuaded Nancy to pass her part in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v(" on to Pam Black.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gawsworth’s painstaking criticism of a small handful of Larry’s poems—the collection that would be published as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ten Poems")]), _vm._v(" towards the end of 1932 by the Caduceus Press—shows that he was an acute judge. ‘A few of these are hardly printable yet,’ he wrote, ‘first because they show too many echoes (which is an adolescent failing of us all) and second because though splendidly musical—bless you!—they are yet in places very obscure.’ Larry must not be rushed ‘when ten days might make ten verses into ten poems!’ Gawsworth was quite specific on influences, but with a prescription for correction: ‘First, you must rid yourself of echoes. I take it as a very great compliment,’ continued Gawsworth tactfully, ‘that after reading me (as you evidently have!) you use quite unconsciously my phrases in parts. Frankly that is not allowable.’ Gawsworth was not angry over the borrowings from his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingcup")]), _vm._v(", but he worried that reviewers would pick them up and "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("chastise Larry: ‘Eliot is the only man who bluffs through “stealing” consistently.’ Gawsworth invited Larry to come over next Tuesday at 11 o’clock, ‘and we’ll spend the morning on them.’ Above all, Larry should ‘grip the pen in hand’ and remember that ‘there’s lots to be thankful for.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn132",
      "id": "ich02fn132",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("132")])]), _vm._v(" Nancy, in turn, took her pen in hand to design a graceful device for the cover, a male lutenist in a long robe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry was humbly grateful for Gawsworth’s critiques, and his literary advice was accompanied by exhibitions of practical lifemanship: his ‘bibliographic breakfasts’ were a revelation to Larry. Gawsworth had an amazing memory for titles, and when short of funds he would sniff with his fox-like nose over the threepenny bargain boxes on the pavement in Charing Cross Road, then plunge in and emerge with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frankenstein")]), _vm._v(" first edition or a rare Edward Carpenter. The next step was to peddle his finds for a respectable sum at Foyle’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gawsworth was a valuable friend, for he was as much a confirmed Londoner as Dr. Johnson, Dickens or Leigh Hunt, and he could guide Larry to the haunts of Goldsmith, Arthur Machen or Ouida, scattering dates, titles and anecdotes as they walked. As a chronicler of the ancient past, the recent past and the present, Gawsworth offered Larry an informal lecture series in literary associations. Gawsworth had met Hardy, Yeats and Wyndham Lewis; he disliked the work of Eliot, Auden and Spender; and it was inspiring to Larry that someone only a few months older than he was a published, respected author: Gawsworth’s poem sequence "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingcup")]), _vm._v(" had gained him a prize and election to the Royal Society of Literature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry may have stood in some awe of Gawsworth, but he soon asserted his independence: Dowson and the 1890s were not for Larry. As "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingcup")]), _vm._v(" faded in his judgement, he would transfer his admiration to Yeats and Lawrence, to Auden and Spender and Eliot—precisely those poets Gawsworth charged with polluting English poetry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was much that Larry admired in Gawsworth as a person, especially his generosity and his total commitment to literature. He had a passion for helping old and forgotten authors, the more eccentric the better, and spent months getting some of Matthew Phipps Shiel’s books reissued. Like Gawsworth, Shiel—author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Purple Cloud")]), _vm._v(" and twenty-three other novels—was a confirmed royalist, but the old man even claimed a kingdom for his own, the tiny island of Redonda in the West Indies, which he asserted the Crown had stolen from his father. What really intrigued Larry was the rumour that Shiel’s father had made a lot of money mining guano—which Larry referred to quite accurately as ‘booby shit.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn133",
      "id": "ich02fn133",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("133")])]), _vm._v(" How "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("wonderful to convert excrement into gold! Many years later in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monsieur")]), _vm._v(", Larry would define gold in satiric terms as ‘the apotheosis of the human turd.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn134",
      "id": "ich02fn134",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("134")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another of Larry’s new friends was the poet George Barker, soon to be associated with Dylan Thomas and the New Apocalyptics. Barker adopted a wild and violent pose in his life and his poetry, a Byronic attitude towards adventure and towards women—the former largely in theory, the latter very much in practice. His face was an attractive blend of the sensitive, the sensual and the athletic. A small scar on his right cheek enhanced his air of raffish strength. He concerned himself in his poetry with love, sex, lust, the fathering of children—and indeed over the years he would father more than a dozen offspring, both in and out of wedlock."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn135",
      "id": "ich02fn135",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("135")])]), _vm._v(" Sometimes in his London days Barker would borrow Larry’s typewriter and bang out poems directly on to the machine, while Larry, who could never write poetry on a typewriter, assumed that he was writing letters home. Like Larry, Barker was mainly self-educated. He concealed behind his combative arrogance and bombast a knowledge of the classics and a deep acquaintance with Villon and Baudelaire, behind his passion and irony a tempering tenderness. His tenderness embraced Larry, but not his writing: near the end of his long life, Barker was dismissive about his friend’s poetry, shouting, ‘It’s the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("man")]), _vm._v(" I love!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn136",
      "id": "ich02fn136",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("136")])]), _vm._v(" This sentiment mirrored perfectly Larry’s own regard for Barker. ‘He is such a sweet and sensitive person,’ Larry would recall, ‘always shying away and twinkling off into the deserts of his own private life like a bushman’s totem. A difficult, painful man, much in need of air uncontaminated by Englishry.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn137",
      "id": "ich02fn137",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the end of 1932 approached, Larry struck out against Christianity, the family and the commercial spirit with ‘The Ballade of Slow Decay’, his first comic poem, printed by Caduceus as an anti-Christmas greeting:")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("This business grows more dreary year by year,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("The season with its seasonable joys.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Lest anyone mistake his attitude, Larry ended a string of mock-serious complaints (‘It makes me want to stamp and make a noise’) with,")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("How can a man withstand the atmosphere,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("This hell compounded of such strange alloys?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Even ‘Grandma’, ‘too old to do a thing but leer, / And call the home-made mince-pies “saveloys”,’ does not elude him."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn138",
      "id": "ich02fn138",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("One of the gathering spots for Larry and his friends was the Fitzroy Tavern in Charlotte Street, with its large saloon bar and friendly proprietor, Papa Kleinfeld. The artist Nina Hamnett, who had known Modigliani and whose nude torso had been sculpted by Gaudier-Brzeska, had returned from Paris years earlier and had searched throughout London for the right combination of ambience, cheapness and an amiable publican. The Fitzroy was it. By the time Larry came on the scene, the ‘old ladies with shawls and bonnets, old men with walrus moustaches’ who came for the Monday night loan club were being edged out by slumming socialites, by the art and medical students bent on a night of thrifty drinking and of ogling the ‘characters.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn139",
      "id": "ich02fn139",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("139")])]), _vm._v(" From Fitzroy Square south along Charlotte Street the neighbourhood was becoming dangerously fashionable for the artistic set, and in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Book")]), _vm._v(" Larry would refer scathingly to the ‘goitered belles of Charlotte Street, and the flat-chested winnies of the Fitzroy Tavern.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn140",
      "id": "ich02fn140",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("140")])]), _vm._v(" But there were still enough interesting people: the Indian novelist Mulk Raj Anand could be encountered in various pubs; also Hamnett was still much in evidence and so was her friend Anna Wickham. Hamnett liked to remind people of her famous Gaudier-Brzeska bust, at the time ‘in the V and A with me left tit knocked off.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn141",
      "id": "ich02fn141",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among Larry’s stranger acquaintances on the margins of literary London were a pair of Polish royalists, Geoffrey and Cedric Potocki de Montalk, claimants to the throne of Poland. Geoffrey and Cedric were born in New Zealand, but apparently they did have some connection with the Polish aristocracy. Both were pale, slender, blue-eyed and gentle-looking. The elder brother went by the title and name of Count Geoffrey Wladislas Vaile, and he sometimes dashed about Bloomsbury in kilts. Nancy would recall going with Larry to their tiny flat near Lamb’s Conduit Street. On the door was a sign, ‘Communists and racial enemies please abstain from calling.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn142",
      "id": "ich02fn142",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("142")])]), _vm._v(" Geoffrey in his customary red robe, Cedric in a deep blue one, were on their hands and knees on the floor, crawling over an enormous map of Poland and quarrelling violently about how the country was to be divided between them. They were right-wing to the point of fascism, anti-Semitic and intolerant, but Larry cherished them as true eccentrics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both Potockis were utterly courageous, willing to risk tumult or gaol in support of their various causes. When Larry met him in the early summer of 1933, Count Geoffrey had been recently in prison for libel, and the first surviving communiqué to Larry includes a request that he check on the delivery of various copies of Potocki’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prison Poems")]), _vm._v(". Count Geoffrey asked Larry to discover ‘whether the die of my coronet has been found, which "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("was wrapped in paper with the coronet embossed, and thrust into a matchbox. Also what has happened to my peasant chairs, mirror, books, etc.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn143",
      "id": "ich02fn143",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This matchbox royalist swept about London and Paris in his long red cape, with a golden cross worthy of an archbishop banging against his navel. He also wrote and published poetry and essays that got him into trouble for their sexual explicitness and their defamatory nature. Nor did Potocki confine his exuberance to print, for he confided to Larry, ‘Mr. Lennon says the Police are after me for a maintenance order, but it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" ridiculous as I haven’t created any bastards, except for the disputed child of Minnie—, who slept with other men beside myself.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn144",
      "id": "ich02fn144",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("144")])]), _vm._v(" Potocki was an exotic addition to his collection of characters, but from the first Larry was cautious, circling the embossed crown on Potocki’s envelope and adding an annotation in green ink, ‘Beware. High Voltage.’ Larry’s instinct, ingrained since his school days, was to avoid trouble from those in authority. Not Count Geoffrey. Later he would found "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Right Review")]), _vm._v(" to be his political voice, and much later still would launch the Melissa Press to print his own ribald poetry and occasional pieces of questionable propriety for his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the 1930s Larry managed to appear singularly apolitical. This was to become known as ‘The Pink Decade’, when a majority of English intellectuals lined up on the left, but Larry came close to avoiding anything beyond a predictably personal stand: the world was going mad, he said, and the madness was threatening to get in the way of his life and his art. He was intent on becoming a Writer, and he happily talked socialism and Communism with his left-leaning friends, royalism with the Potockis. In fact, he was already developing that disbelief in the efficacy of political institutions that he would express so fully in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bitter Lemons")]), _vm._v(". Pressed to choose, Larry would confess to a conservative bias.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s caution did not prevent him from expressing his opinions of others’ writing. He enjoyed firing off squibs, twitting his elders. His first target was George Bernard Shaw. In 1933 the Caduceus Press published a slender hardback book with a mock eighteenth-century title page: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bromo Bombastes: A fragment from a laconic drama")]), _vm._v(" by Gaffer Peeslake, ‘which same being a brief extract from his Compendium of Lisson Devices.’ In this booklet Larry slyly pokes fun at Shaw’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Adventures of the Black Girl in Her Search for God")]), _vm._v(", written the year before. For the entire six pages of the text a Reporter interviews a Silly Black Girl, identified by the initials SBG.")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("What did you seek so far away")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "block"
  }, [_vm._v("In Chesapeake, Kabul, Bombay…?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("asks the Reporter, to which the SBG answers:")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("Strange as it seems I was seeking God,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Treading the paths his feet have trod.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("The SBG concludes ‘that God resides in Whitehall Court.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn145",
      "id": "ich02fn145",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("145")])]), _vm._v(" Only the pseudonym Gaffer Peeslake appeared on the title page, and Shaw gave no sign of knowing that he had been under fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bromo Bombastes")]), _vm._v(" was more significant for Larry’s development than either the conservative dramatic form or the mild satire would indicate. The stage directions show Larry’s first experiments with surrealism: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Here is a pause during which")]), _vm._v(" [the Reporter] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("makes symbols on a roseleaf, in goat’s blood")]), _vm._v(".’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn146",
      "id": "ich02fn146",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("146")])]), _vm._v(" While ostensibly attacking him, Larry must have realized that Shaw, in favouring the merciful and humane God of Micah over the ‘Bogey Man’ God of Noah and Job, was also repudiating ‘Granny’s God.’ Shaw, an Irishman with an English reputation, seemed to Larry almost a father-figure, and Larry would later appeal to him on behalf of Henry Miller for backing in a censorship battle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The acquaintance with London’ bohemian fringe would provide Larry with settings and colour for long sections of his first three novels. In retrospect, he liked to emphasize the hardships of his Bloomsbury existence: ‘I was on my uppers at the time…. All we ate was chips, washed down with a couple of pints of beer, when we could borrow the dough. I was perfectly capable of sleeping in the street.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn147",
      "id": "ich02fn147",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("147")])]), _vm._v(" This was sheer romancing: Larry assuredly never spent a night on a park bench, although he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("might")]), _vm._v(" have been tempted to do so to prove a point. True, he could not afford many luxuries, and according to Nancy he could not follow a budget. The monthly sum Larry got from his mother was not quite sufficient, even for the marginal life that Larry and Nancy chose to live. The couple tried every expedient they could imagine to add to their income. When his friend Jeff—Cecil Jeffries—opened the Blue Peter, a none too respectable nightspot lit with dim blue lights in St Martin’s Lane near Leicester Square, Larry put in a few evenings a week playing the piano. He still could not reliably read music but he could ‘strum quite gaily’ such popular numbers as ‘Trees’ and ‘Smoke Gets in Your Eyes.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn148",
      "id": "ich02fn148",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("148")])]), _vm._v(" Accompanying himself, Larry sang in a pleasant light tenor ‘dance tunes’ of his own "), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("composition, among them ‘Two of a Kind’ and ‘Out of the Blue.’ ‘Love, you’re a peach’, Larry would croon. Sometimes he had help on the vocals from a singer named Dixie Lee.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn149",
      "id": "ich02fn149",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("149")])]), _vm._v(" Nancy was ‘incensed’ when Harold Nicolson turned up with several male friends and, putting his hands on Larry’s shoulders, murmured, ‘Do, darling, do play “Trees” again.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn150",
      "id": "ich02fn150",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("150")])]), _vm._v(" The Blue Peter is the flag raised by ships on the point of departure, and at this stage Larry and Nancy seemed always on the verge of departure for somewhere. One such departure was accelerated by the police, who terminated Larry’s performing career by raiding the place, and he had to escape from the second storey by sliding down an outside drainpipe—his years of tree-climbing in Kurseong came in handy. During this period Larry spent a couple of weeks as an apprentice racing car driver for the Morris Garages team. He had a few practice sessions in the beautiful ‘racing cars with strapped-down bonnets’,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn151",
      "id": "ich02fn151",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("151")])]), _vm._v(" but was never to drive in competition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he was not attempting some ploy or other to augment his tiny income, Larry was often found under the great dome of the British Museum reading room. He read rapidly, recording passages and writing observations in a ruled notebook. Unlike Nancy, Larry was not keen on art exhibitions, but he developed a passion for Turner’s landscapes. When they had funds Larry and Nancy went to shows like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funny Face")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Charlot")]), _vm._v(". Or they braved a night club to hear Leslie Hutchinson, ‘the divine Hutch’, play the piano and sing ‘Life Is Just a Bowl of Cherries.’ Sometimes the chilly London dawn caught them walking back hand in hand from the south bank across Westminster Bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Living in London had shown Larry what could be done with only a little money, and he was alarmed by the rate at which his mother was spending the capital his father had left. He set out to persuade her to settle on him what he figured was his share of the estate. His confrontation with Louisa Durrell went something like this: ‘You’re chucking it down the drain. In another few years there won’t be any left. I want my bit now.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn152",
      "id": "ich02fn152",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("152")])]), _vm._v(" His ‘bit’ amounted to capital that would produce three pounds a week, enough for mere subsistence in London. He and Nancy wanted more than a bare minimum, so they continued to try various shifts to make money. The most promising venture that the pair undertook was to open a photography studio. After Nancy left "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v(" she had gone to work for a commercial photographer off Charing Cross Road. ‘This seems to be a piece of cake,’ she told Larry. All they would have to do was to take photographs and flog them around. On Larry’s suggestion they applied to Nancy’s father for a loan to establish Witch Photos. Thomas Cyril Myers, "), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("sole issue of the Reverend Thomas Myers, had never been happy with his daughter’s stage career, which he had angrily called ‘kicking your legs up on the stage’—never mind that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v(" was a rather highbrow drama about a girls’ school.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn153",
      "id": "ich02fn153",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("153")])]), _vm._v(" Around February 1933 he doled out £300 that would in any case be Nancy’s by right in a few months’ time on her twenty-first birthday. Her grandfather the Reverend Thomas Myers had settled sufficient money on her so that even after her school fees and various family living expenses had come out of it, there was still around £3000 remaining. Also, her second cousin Harold Fielding Hall, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Soul of a People")]), _vm._v(", had left her the respectable sum of £1000. Nancy and Larry leased a large basement below Sheffey’s, a small café off Lamb’s Conduit Street. They moved in a few pieces of second-hand furniture and called it home. The area had literary resonances: Gawsworth told Larry that it had been one of Dr. Johnson’s haunts. Sheffey herself claimed to be a gypsy; at any rate, she took to her new neighbours and when Nancy was not cooking they ate their meals with her, often joined by Joseph Allen, Cecil Jeffries, George Wilkinson and other friends. Sheffey was a local character, with a dangling cigarette, a deep croaking voice, rouged cheeks, dyed black ringlets held in loose order by a scarf."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn154",
      "id": "ich02fn154",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("154")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Statesman")]), _vm._v(" would publish an obituary when she was killed by a bomb during the coming war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry set himself up as the proprietor of Witch Photos, located in a loft on Millman Street: he bought a roll-top desk, ‘an enormous imitation leather armchair’, a condenser enlarger and a stock of Amidol developer, and sat back to wait for clients. Nancy’s parents gave her a silver fox fur on 8 May, her birthday, and the young couple felt themselves speeding along the high road to affluence. George Wilkinson was able to steer A. J. A. Symons, then finishing his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quest for Corvo")]), _vm._v(", to Witch Photos for a sitting. Unluckily, Pike the dark-room technician had either loaded the film plates backwards or had speckled them with acid during the processing, for Larry had to ask Symons back for a second sitting. This time Symons ordered a dozen of the ‘serious compton-mackenzie-esque photographs.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn155",
      "id": "ich02fn155",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("155")])]), _vm._v(" Their friend Peter Bull was the other paying customer—there were only these two that Nancy could recall—although there was a non-paying one, a ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" vulgar man’ who wanted to market pictures he took of Nancy and Pam Black ‘in camiknickers.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn156",
      "id": "ich02fn156",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("156")])]), _vm._v(" Larry and Nancy tried to get together a portfolio in a bid for a contract to photograph underwear for British Celanese, British licensee for the new DuPont synthetic fabrics, and they persuaded Joan Reed, daughter of the Managing Director of Reed Paper and studying "), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("at the Slade, to model for them. Both Larry and Nancy took endless exposures of Joan, amid much hilarity. For most of the summer Joan practically lived with them. She admired Nancy immensely: to the ‘charming spoilt baby’ Larry, Nancy was ‘mother and manager, his muse of course’, his ‘equal in intelligence and his superior in character.’ Larry was ‘endearing’, and he and Nancy worked together in great harmony.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn157",
      "id": "ich02fn157",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("157")])]), _vm._v(" Joan was especially struck by ‘his intense curiosity and interest in other people & therefore their sex.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn158",
      "id": "ich02fn158",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("158")])]), _vm._v(" Nothing came of their efforts to break into advertising, and finally even Larry had to admit that Witch Photos was a failure. He shrugged it off but Nancy felt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bürgerlich")]), _vm._v(" guilt at wasted capital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry had not neglected his writing while sitting at his roll-top desk, and had produced a number of poems. One project that occupied him and his friends was the translation of the Comte de Lautréamont’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Les Chants de Maldoror")]), _vm._v(". ‘My share was to supply the “poetry” to the text,’ Larry recalled."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn159",
      "id": "ich02fn159",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("159")])]), _vm._v(" Le Comte de Lautréamont was important to Larry in other ways as well: his example encouraged Larry’s natural drive towards early accomplishment. The author was a double being with an invented name, for his legal name was Isidore Ducasse; also, like Larry he was an expatriate, born to European parents in Montevideo. The imaginings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maldoror")]), _vm._v(" suggest the hallucinations of a brilliant madman, and the precocity of the author—Lautréamont was only twenty-four when he died—recall Rimbaud, another of Larry’s icons. Author and character sometimes appear to merge, but at other times Lautréamont speaks at odds with Maldoror the character, setting rational hope against Maldoror’s blank despair. Madness, the author-character relationship, Manichean dualism all became preoccupations for Larry. Also, the effort of translation threw Larry deeper than ever before into French literature. No publisher would touch the translation, but both the surrealism and the extravagant language of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maldoror")]), _vm._v(" point towards the prose fantasies ‘Asylum in the Snow’ and ‘Zero’ that Larry was to write for Henry Miller and Anaïs Nin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were a lot of high jinks to break up the serious effort. ‘I remember Larry and Nancy … Peter Bull, myself and George enjoying life in London,’ said Pam Wilkinson."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn160",
      "id": "ich02fn160",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("160")])]), _vm._v(" In his mother’s Hillman saloon, Larry drove his friends on various excursions outside the city. ‘One night we all motored down to Sussex and swam in an old pig pond and ended up in my mother’s cottage at Ditchling,’ recalled Pam. Nancy did not think it had been a very glamorous plunge, but this wild night suggested to the two couples that life in a cottage might beat life in Bloomsbury. They began to search for an ‘old beamy cottage’ and soon turned up Chestnut Mead, "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("nearly a mile outside Loxwood in Sussex, which they could have for a pound a week.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn161",
      "id": "ich02fn161",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("161")])]), _vm._v(" Each was to contribute five shillings. Cassell had offered a prize of £300 for a first novel and Larry and George decided to submit entries. Larry planned to write a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("roman à clef")]), _vm._v(" based on his early life, with a protagonist who was himself in a thin disguise—only a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tall")]), _vm._v(" boy: Larry felt he was entitled to that. Larry, Nancy and George were to live permanently at the cottage, while Pam was more often than not away on tour with the Birmingham Repertory Company in the cast of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in Uniform")]), _vm._v("."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn162",
      "id": "ich02fn162",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("162")])]), _vm._v(" They bought, very cheaply, two beds, a few chairs and a table. George climbed a narrow oak staircase to his bedroom-cum-study and Larry spread over the rest of the house, writing on the table in the ground floor sitting room. Nancy bought Larry a second-hand Challen baby grand piano for £60. George had a set of drums and cymbals, and in the evenings they held jazz sessions. Larry renamed the house Little Songhurst Cottage in honour of the songs sung and the marvellous poetry still to be written there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy did most of the housekeeping and cooking—and tried to concentrate on her painting. She had two cookery books, one Italian and one of a distinctly health-food cast: her cuisine ran to strange concoctions involving lentils, beans, rice and fried onions; and she stewed a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("carbonnade")]), _vm._v(" in beer. All in all, it was a significant improvement over fish-and-chips eaten out of a fold of newspaper. George did the washing up and Larry occasionally emptied the Elsan earth closet—which would turn up in the Scobie passages of the future "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alexandria Quartet—")]), _vm._v("kept in the outdoor privy. They took baths in the kitchen almost as a matter of principle: they thought themselves too advanced to need privacy. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No shame")]), _vm._v(" was the motto Larry would give Walsh Clifton,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn163",
      "id": "ich02fn163",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("163")])]), _vm._v(" and the Songhurst denizens tried to make it theirs as well. Shame was an invention of Pudding Island. ‘It might be a really exciting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("refinement")]), _vm._v(" to have one’s dinner cooked by a nude wench,’ Larry would write in his novel."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn164",
      "id": "ich02fn164",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("164")])]), _vm._v(" Nakedness became part of their statement of revolt. The Loxwood villagers called them ‘the three sketches’ and, except for the parson, left them strictly alone."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn165",
      "id": "ich02fn165",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("165")])]), _vm._v(" That gentleman called once and spent twenty minutes in earnest conversation with the trio before retreating, his upper lip stiff with disapproval.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry was not only on the receiving end when it came to criticism, moral or literary. Reginald Hutchings, a Bloomsbury friend, had shown Larry various poems in typescript, and wanted him to look at some more recent work on his coming visit to Little Songhurst Cottage. He wrote to Larry, ‘The value I place upon your criticism is such that I propose to postpone "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("discussion until I see you.’ Larry must have been chastising him on his borrowings, for Hutchings defended himself: ‘I am convinced there is little of Eliot in my work.’ What appeared to be direct influence was more likely due to the fact that he was interested in the same writers who had influenced Eliot: the lesser Elizabethans as well as Mallarmé, Valéry, Laforgue. Hutchings had almost given up reading his contemporaries’ work, and had found the early Elizabethans ‘my first and only constant love.’ Larry considered the Elizabethans enough "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" property to bristle. Hutchings continued, ‘Marsh, myself, our respective mistresses, and Anand (possibly)’, were going ‘next weekend’ to see Count Cedric Potocki in Philip Marsh’s car, and then he would drop in on Larry. Some months later Larry handed Hutchings’ letter to a new friend, Alan G. Thomas, with the scornful comment, ‘Hutchings’ wee note should give you a hell of a laugh.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn166",
      "id": "ich02fn166",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("166")])]), _vm._v(" Larry was quick to winnow his friendships: many he cast off quickly; where he found some indefinable kinship nothing else mattered. He was well aware that a web of influential connections among the London creative and journalistic set was a powerful aid to the construction of a literary reputation, but he had a visceral hatred of what he termed ‘bum-sucking.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Little Songhurst Cottage George and Larry would write well, live cheaply and walk in the quiet countryside, so their theory went. Larry was not one to languish in a pool of quiet, however, and there were tensions within the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("menage")]), _vm._v(". Nancy was intense in her opinions and quick to jump into any verbal fray. Pam’s happy-go-lucky gaiety could have made her a tempering influence, but she was away much of the time. George was very meticulous and very orderly, traits that Larry possessed only at odd moments. Larry could not resist the temptation to bait the schoolmasterly George. The Wine and Food Society had just been founded by Symons, George’s benefactor, and one day while he and George were chopping wood, Larry delivered a magnificent tirade against it. And there were other disputes, usually with Nancy joining in stridently. Following one particularly intense wrangle, George wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "blocks"
  }, [_vm._v("My Dear Larry,")]), _vm._v(" "), _c('p', {
    staticClass: "blocksi"
  }, [_vm._v("After a morning spent in pondering on the inadvisability of early morning reprisals, I am moved to take up a pen. My criticism was not only ill-timed but ill-considered. I feel sure that with a little mutual effort we shall contrive to live without much friction. But you must bear in mind that I am a slow-witted plodder & find it difficult to follow your voltes-face.")]), _vm._v(" "), _c('p', {
    staticClass: "blocksi"
  }, [_vm._v("It is probably your spouse who is more in need of reassuring than you. The way "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("she thrusts her stones down my throat was unmistakable. Please carry Nancy my apologies & return her stones; I don’t want to eat them, I want to cook on them.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "blocksi"
  }, [_vm._v("We must keep the cottage safe for Democracy.")]), _vm._v(" "), _c('p', {
    staticClass: "blocksa"
  }, [_vm._v("I think the cabbages are dying.")]), _vm._v(" "), _c('p', {
    staticClass: "blocks1"
  }, [_vm._v("Yours ever")]), _vm._v(" "), _c('p', {
    staticClass: "blocks1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("George")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The cabbages may have succumbed but the friendship survived.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("An important cause of the tension at the cottage was that George, desperately eager to become a writer, lacked the gift, and felt threatened by the litter of typescript pages around Larry’s machine after a morning of writing.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn167",
      "id": "ich02fn167",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("167")])]), _vm._v(" Although he used only two fingers he typed rapidly, and the syncopations of his machine, clattering through the small cottage, sounded to George like the volleys of an enfilade. Quickly, the scattered sheets were forming into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(". The book was to be a memorial to the Kim aspect of Larry’s past. He was making the first third a paean to an idealized India: here was the great, fecund land, kaleidoscopic in colour and symphonic in sound, that had given birth to him and that he had lost. Curiously, though, while Larry praised the ‘hill servants’, he portrayed the run of the lowland natives in caricaturing terms that would have amused the most "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pukka")]), _vm._v(" sahib: they were thieving, grovelling ‘sons and daughters of sows’ with ‘raised … black paws’, and they beat their wives."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn168",
      "id": "ich02fn168",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("168")])]), _vm._v(" Two sides of his personality were striving with each other to take over the narrative: the modern romantic who pierced through the great façade of Empire, and the colonial boy who still saw with his dead father’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he reached back into his memory, Larry realized that his father stood at the crux of his early life, and that he had to come to terms with his vanished parent. In particular, Durrell-the-author revisited perceived wrongs inflicted upon him by his parent. In these re-creations, Larry showed the father-figure remorseful for misleading his son about promised school holidays, riven with guilt for allowing him to grow up lonely. He constructed passages in which Walsh triumphs over his father when he thinks himself disciplined unjustly. In fact, so often does Walsh triumph over his various adversaries through the perfect retort or the well-timed punch to the nose—the way most people wish after the event that they had said or made the perfect rejoinder—that the book suffers from a sense of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("post facto")]), _vm._v(" revision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than a mere revision of the events of his early life, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" was an important attempt by Larry at auto-analysis. He had been reading Freud diligently by 1934 and dabbling in the psychoanalysis of his family and "), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("friends. Larry has Walsh, ironically called ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gipsy Clifton, skilled psychologist")]), _vm._v("’, examining his teachers: ‘In a week Walsh had discovered that his housemaster was suffering from a repressed libido; that Binhook had a very marked shin-fetish; and that the head master was in possession of a “marked psychic derangement”.’ Whenever exactly Larry started reading Freud, it was as dangerous as giving explosives to an anarchist. ‘If it’s true,’ Larry wrote, ‘then none of us can be really responsible for our actions —.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn169",
      "id": "ich02fn169",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("169")])]), _vm._v(" The entire issue of moral judgement threatened to come loose. ‘Very roughly’, Larry wrote, ‘it amounts to what you feel being right, and what you know being wrong.’ Somewhere in the back of Larry’s mind stood D. H. Lawrence, with his call for trusting instinctual ‘blood knowledge’ over mind knowledge. Larry was discovering for himself ‘the majesty of living, the greatness of the body.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn170",
      "id": "ich02fn170",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("170")])]), _vm._v(" He tried to convince himself that he was a true Dionysian, writing of his surrogate, Walsh, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All philosophy seems to lead me towards a perfect spiritual detachment—a divorce from the world, and therefore towards sterility and deadness. Let me be content to say: I am, and content to “be” as fully as possible")]), _vm._v(".’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn171",
      "id": "ich02fn171",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Continuing his dialogue with his dead father, Larry would still have him die, but in a more dramatic way than his real death had been. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" the son dreams, prophetically, that his father is killed by a hamadryad, a king cobra: Walsh, who had himself earlier killed a cobra, thus earns the right—which he does not want—to succeed to his dead father’s place in the family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor was Larry able to assume his father’s place, even though his mother was apparently willing to heed his advice, to follow his lead. There was the money-guilt, the sahib-guilt: Larry had wasted his father’s hard-earned money in a vain assault on schooling, and at an age when his father had been leading hundreds of men in bridge-building crews, Larry led no one. Rationally, Larry could write in scorn of the vast number of senseless things that he had been forced to study, and of the empty values of the Empire Builder, yet in his fully conscious other self he felt that he was letting his father down. However, he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to turn against his father’s world, to reject his father’s plans for him: there was to be no return to India as a doer, as ‘a great man in a dinner jacket.’ ‘He would have liked to explain the whole matter, gently and clearly, to his father,’ Larry wrote of Walsh. Once Larry had killed off John Clifton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" weakened in intensity. Because his father had let him down by dying, Larry felt that his own growth had been arrested: he would never be able to explain himself to his father and thus ease his conscience. In any case, like many young men, ‘He was not certain "), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("of his path.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn172",
      "id": "ich02fn172",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("172")])]), _vm._v(" As though by design, Larry had remained short, almost a boy in height, an adolescent in visage. The conflict with adult responsibilities remained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry used the event of John Clifton’s death to mark a watershed in the development of Walsh, and he digressed from the plot structure of the novel to probe what was emerging as his own dark obsession, the carefully hidden side of his character. Larry/Walsh ‘realized more clearly the huge, heart-breaking doom of living; the pathos of a perpetual search which must always end; of a mind loaded with eagerness to find something—it could not tell what—and broken by the weight of that load, and by its own inability to do anything but become involved in speculations and quests which seemed to lead it farther away from its unknown objective.’ If Larry did not take the escape offered—his father’s occupational route, the equally narrow route of writing-for-money, any mundane goal, it did not matter which—then, he realized, his would be the doom and the grief of living without boundaries, making the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("search")]), _vm._v(" his object, a search that must end, not with a finding but with death. ‘He had outgrown the shams,’ Larry wrote with what he must have hoped was a personal fit. Larry did not claim this as an unexampled predicament:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("He saw, too, with the detachment of unspoken grief, that the burden was laid not only across him, but across the whole of mankind … and that there was for him as for them, one escape and one only; and that was towards the illusions of a narrow life, towards the fear of a fickle and futile opinion, towards mental sterility and cowardice and the thousand and one dreary shams of middle-class society."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn173",
      "id": "ich02fn173",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("173")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Often Larry was impelled to consider the security of a plotted route, yet time after time he hesitated. His decision would hinge upon the state of his self-confidence at the moment: if he really did possess some rare talent, then he should not give in. If he did not … well, the sooner he sold out the better! ‘Was it simply the same idiot hunger after beauty that everyone experienced?’ he asked bitterly. ‘Or was it some unique private gift, vouchsafed only to the few chosen ones?’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn174",
      "id": "ich02fn174",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("174")])]), _vm._v(" This was not the first time he had asked himself these questions, nor would it be the last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One self-discovery that Larry had indeed made was that he needed to be a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("maker")]), _vm._v(", a doer, whether a poet or an iron-founder."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn175",
      "id": "ich02fn175",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("175")])]), _vm._v(" Now he had to be concerned with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how")]), _vm._v(". ‘I have discovered that each progression in my life brings a new battery of guns against me,’ Larry wrote in reflection of his own dilemmas, the conflicting demands of family and of artistic freedom."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn176",
      "id": "ich02fn176",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("176")])]), _vm._v(" Clearly he was not going to turn iron-founder: that would be "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("too close to his father’s career. How was he to write, then, about his preoccupations, the plastic lusts that shadowed his speculations? ‘I could … chatter on for pages of the marvellous properties of the flesh—flesh limp, flesh supple, flesh sun-pink, flesh tender, flesh lustrous, flesh taut, flesh everything and flesh nothing whatsoever,’ Larry wrote. He wondered whether sculpture might not be the best medium in which to express himself. ‘Space against Time curves and stresses, structures and dimensions,’ he said, borrowing from theoretical physics. ‘How in hell can I express the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("volume")]), _vm._v(" of things by daubing ink on paper?’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn177",
      "id": "ich02fn177",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("177")])]), _vm._v(" Larry needed a literary form that would have architectural bulk and shape, but that would have to wait until he was ready to write "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Alexandria Quartet")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In making fiction out of his inner struggles, Larry prefigured the Pursewarden/Darley relationship in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Alexandria Quartet:")]), _vm._v(" just as Larry has Robin Ames lecture Walsh as ‘my good ass’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", more than two decades later Larry would delineate the friendly but condescending confidences of Pursewarden to ‘Brother Ass.’ Even this early, his own inner dialogues were conducted in two voices: the critical wiser self and the mawkish naïf. This was also early evidence of Larry’s disbelief in the discrete ego: the ironic observer and the observed could, he well understood, reside in the same skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the main events in the Indian chapters remained highly autobiographical, Larry omitted nearly all of the family relationships that he had grown up with. Through Walsh’s widowed Aunt Brenda, Larry was able to set down the sufferings of his own widowed mother: ‘There had been the months of retrenchment’, he wrote, ‘behind the aegis of cheap novels, cheap gossip, tea-parties and prayers.’ Then just as Louisa had pulled herself together to look after her children, Larry gave Brenda a new role in caring for Walsh."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn178",
      "id": "ich02fn178",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("178")])]), _vm._v(" The rest of the novel flowed quite naturally, if less poignantly, from his school life at St Edmund’s and from his years in Fitzrovia and in the Reading Room of the British Museum. Fragments and echoes of the Eng. Lit. curriculum of his school years appeared: Marlowe, Swift, Pepys, Gray’s ‘Elegy’, William Morris, Masefield’s ‘Cargoes’, Rupert Brooke, Petrarch. Echoes of his wide reading crowded into the book. Petronius, Rabelais, Rimbaud and Verlaine hinted at the scandalous. Gerard Manley Hopkins and Ezra Pound were among the poetic god-fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry presented the bohemian world of central London around the British Museum in terms of the clichés of urban degradation, which he none the less professed to find life-giving ‘after the soulless, empty ugliness "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("of Dulwich.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn179",
      "id": "ich02fn179",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("179")])]), _vm._v(" The landlords seemed all to be Jews who ‘grappled’ their ‘hard hands together’ as they made ‘grasping demands.’ ‘The women were mostly Jewesses’, Larry wrote, ‘with black, weary-looking eyes, and their bodies under their coloured coats supple as greyhounds.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn180",
      "id": "ich02fn180",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("180")])]), _vm._v(" Jews were ‘sallow’ and ‘pallid’; ‘their coats were padded out about the shoulders to give them the appearance of physique which they did not possess.’ While Larry does not give them specific criminal activities, they are clearly predatory, like underworld cartoons from Dickens or Henty. In contrast, Larry’s sympathetic portrait of a ‘tall negress’ with a ‘beautiful silver-coated whippet on a lead’ suggests direct observation. The woman hums in a ‘very melancholy but not displeasing’ voice."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn181",
      "id": "ich02fn181",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("181")])]), _vm._v(" Larry reserved the right to be selective in his middle-class prejudices, some of them prejudices that he would later repudiate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon Larry was typing the Epilogue, and near the end he has the heroine call Walsh Clifton ‘De Gourmont’s faun’,"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn182",
      "id": "ich02fn182",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("182")])]), _vm._v(" an indication that Larry was already familiar with Rémy de Gourmont’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Natural Philosophy of Love")]), _vm._v(", a book that would echo through Larry’s novels all the way to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Alexandria Quartet")]), _vm._v("."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn183",
      "id": "ich02fn183",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("183")])]), _vm._v(" Larry ended his first novel with a major personal apprehension that would spur on his hedonism and add urgency to all his striving: it was ‘mental dynamite’, the realization that ‘I am and quite soon I will not be.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn184",
      "id": "ich02fn184",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("184")])]), _vm._v(" This awareness of the ridiculous brevity of life produced the companion thought, ‘What a desperate frolic life is.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn185",
      "id": "ich02fn185",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("185")])]), _vm._v(" Of course these are among the oldest of all human speculations, but they hit Larry early and hard. Also, they had the effect of focusing him upon his ‘Inself’, as he called it: ‘My sensibility is the only laboratory in which work is carried out that interests me at all,’ he wrote."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn186",
      "id": "ich02fn186",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("186")])]), _vm._v(" The outer world was secondary to his mental life, and he was soon to express this inner world in terms of his own Heraldic Universe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s later hand-wringing about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" was to an extent justified. The title is wildly inappropriate to a death-haunted book; the novel is a prosaic tale of growing up, rendered interesting in the first third by the Indian setting; the occasional editorial voice is intrusive; the characters tend towards caricature, or are simply flat; the dialogue is often stilted; and so on. However, Larry’s disclaimers and all cavils to the contrary, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(" was an important beginning. He established death as the great counterpoise to love in his writing—metaphysical speculation against sexual curiosity, if you will; like his beloved Elizabethans and Jacobeans, Larry worked in a blend of the tragic and the humorous; he struck a vein of Gothic horror; he proclaimed a personal ethic—‘No shame’ "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("— that would for better or worse last him a lifetime; he sketched in at least a part of the symbolic structure, including the serpent motif, that would recur in his writing until his final fiction; he provided glimpses of the mastery of place that would distinguish his mature prose.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("For Larry himself, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" functioned in yet another manner: to an extent, it laid the ghost of his father. Larry had felt guilty over the death of his father "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("because he had willed it")]), _vm._v(", although doubtless unconsciously. Lawrence Samuel, suffering from a brain tumour, had died first in the mind, the ultimate willed death. His father’s death had freed Larry in all the classical Freudian senses, but it also freed him to live as he wanted to live, not along the lines his father expected. When asked late in his life why he had written almost nothing else dealing with India, Larry replied, perhaps disingenuously, ‘So rapidly I became a European that my source material ran out. And anyway, Forster had done it so much better than one could hope to do.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn187",
      "id": "ich02fn187",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("187")])]), _vm._v(" Larry also realized how much he had revealed in the novel: that is perhaps the unadmitted reason why he would not permit its republication, why he would never write another Indian novel, and why he was reticent about India. His father’s ghost had to stay buried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As summer approached, Larry was working on the final revisions of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", but George was still floundering. He and Pam decided to get married and, for a honeymoon, bicycle to Corfu. Peter Bull, now in the cast of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Escape Me Never")]), _vm._v(", was their best man at the Kensington Register Office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was June when the Wilkinsons left, and Larry and Nancy stayed on at Loxwood for the few weeks the lease had to run. Along came Count Cedric Potocki, the younger de Montalk, bringing his oversized American mistress and her young daughter. He walked up to the door in his rippling robes, suffering from toothache, his head bound in a white scarf knotted on top, and moved in. When the lease on Little Songhurst ended, Larry had had enough of Potocki and went to visit his mother in Bournemouth; Nancy moved to an even more primitive cottage to stay with Count Cedric and ‘Madame’, as the Count insisted his lady be called. Immediately Nancy came down with measles. She got a message through to Larry, who came post-haste, and together they retreated to Dixie Lodge and Louisa’s care.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the time at Loxwood, Larry had done more than write fiction and argue. He had composed a number of passable poems and had sent a fan letter to Richard Aldington, whom he particularly admired. "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("Much to his surprise, Aldington replied in September with a friendly letter discussing D. H. Lawrence and Aldous Huxley. Uncharacteristically, Larry did not reply. ‘I was too unsure of myself, too diffident,’ he recalled many years later; Aldington had seemed to him, if not quite one of the giants, a top-rate man of letters, and Larry had worried about seeming to curry favour.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn188",
      "id": "ich02fn188",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("188")])]), _vm._v(" Also, he no more wanted to follow in Aldington’s footsteps than he did in Richard Blaker’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s failure to respond to Aldington meant more than just the diffidence that he claimed, although his modesty was genuine enough. Larry knew that, intellectually, he had been a league ahead of most of his schoolfellows; he also knew that he was a good writer and could perhaps become a fine one. However, he was unsure—and would remain so for the rest of his life—how far his talent would carry him. He was also terribly afraid of appearing to assume that he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deserved")]), _vm._v(" patronage, nor did he want success on those terms: he had too much pride. Three decades later he would worry about being exposed as a ‘charlatan’, and in this too he would be sincere. The self-confidence that would lead him to make pronouncements suggestive of the most glaring hubris could evaporate in a flicker. Was he indeed merely a bumptious colonial brat, Larry would wonder, in between flashes of powerful belief in himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s move to Bournemouth would bring him two major blessings, one indirect and one evident. It provided him with a second focus, after London, for his anger at England and sent him off in the direction of Greece. The landladies and the tourists and the retired civil servants showed him his ancestral countrymen at their least sympathetic. One senses his desperation in the thoughts given to Horace Gregory in the future "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Book:")]), _vm._v(" ‘In Bournemouth, walking the streets, while the rain pronged the lights and houses, the whole shape of my future rose up and choked me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn189",
      "id": "ich02fn189",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("189")])]), _vm._v(" For relief Larry went almost every day, usually accompanied by Nancy, to the H. G. Commins Bookshop, owned by Ernest Cooper. There he met the owner’s chief assistant, a tall, angular, aesthetic young man named Alan Gradon Thomas. Apart from his passion for literature and his luminous sense of humour, Alan seemed the antithesis of Larry. Raised a Quaker, Alan was shy, introverted, careful, deliberate, orderly, precise. He was also a passionate, self-educated mediaevalist—and he looked the part, with his long jaw and narrow aquiline beak. Whereas Larry had learned to project infinite confidence despite his inner doubts, Alan could be painfully self-deprecating. He was to become Larry’s longest-standing friend as well as his bibliographer and the preserver of his library and files during the "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("upheavals of war, divorce and other misadventures. Alan would always be available as a reliable sea-anchor, to be called upon whenever Larry felt that he needed to be headed into the wind.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon Alan was spending most of his evenings and his weekends with the expanded Durrell family. He wrote an eyewitness account of the Durrells at home:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("All six members of the family were remarkable in themselves, but in lively reaction to each other the whole was greater than the sum of the parts. Amid the gales of Rabelaisian laughter, the wit, Larry’s songs accompanied by piano or guitar, the furious arguments and animated conversations going on far into the night, I felt that life had taken on a new dimension. Larry was writing, Nancy painting, Leslie crooning, like a devoted mother, over his collection of unlicensed firearms…. Every basin in the house was unusable because Gerry, then only a little boy, but already an animal collector, had filled them with newts, tadpoles and such-like; he roped me in to serve as a giant in the circus which he organized in the garage. Margaret, realizing that book-learning was no part of her world, was rebelling against returning to school, and soon succeeded, backed by the rest of the family, in staying put.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("Although all the Durrells had been born in supposedly non-violent India, their tempers were Irish and the rows were frequent. Once Larry, in order to wash, had pulled the plug on one of Gerald’s impromptu aquariums. Almost speechless with rage and searching for the most insulting word he could imagine, Gerry attacked: ‘You, you … you AUTHOR, YOU!’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn190",
      "id": "ich02fn190",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alan introduced Larry to Patrick Evans, whose father had built a house on the edge of Sway in the New Forest, not far from Bournemouth, after his retirement from the headmastership of Leighton Park, known as ‘The Little Eton of the Society of Friends.’ Pat, who studied at Oxford when he was not at Sway, was in rebellion against his parents, the Quakers and the university when Larry met him. Tall and fine-looking, he was a good jazz pianist and he was also classically trained. Pat, Alan and Larry tried their hands at writing jazz and popular songs, aided by Leslie."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn191",
      "id": "ich02fn191",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("191")])]), _vm._v(" Pat composed his own tunes for foxtrots and waltzes, sometimes providing ‘doggerel’ to go with them, and also set down the notes for the melodies Larry improvised on the piano, after which Larry would make up verses to go with the music."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn192",
      "id": "ich02fn192",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("192")])]), _vm._v(" One of Larry’s efforts was a set of lyrics for a waltz, ‘Three Pawnbroker’s Balls’:")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("Look how they’re getting me down —")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Had to sell everything out of my flat,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("My wife, her mother, the dog and the cat,")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "block"
  }, [_vm._v("Now what do you think is the cause of that?")])]), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("Why, Balls, Balls, Balls.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn193",
      "id": "ich02fn193",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("193")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sometimes Larry tried to milk a frankly sentimental muse: ‘When you go, I know it’s Paradise lost.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn194",
      "id": "ich02fn194",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("194")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another pianist Larry met was Evelyn Lewton-Brain, a classical performer and music teacher only a year or two older than Larry. They got together for composing sessions, with Larry providing words and scratch melodies, Evelyn working out and setting down the counterpoint. She was a small, attractive woman and although he introduced her to his family, Larry did not include her in the circle of his other Bournemouth friends."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn195",
      "id": "ich02fn195",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("195")])]), _vm._v(" They all dreamed of making easy money by writing a few hits. Larry would project this dream into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panic Spring")]), _vm._v(", his second novel: Walsh Clifton, shown a year or so older than he was at the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", is able to support himself on the Greek island of Mavrodaphne by writing tunes to accompany ‘greasy’ lyrics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guided by Pat, Larry and Alan took long Sunday walks through the New Forest, ‘dew on the nose and rime i’ the boots’, stopping at small village pubs for beer and a game of shove-ha’penny."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn196",
      "id": "ich02fn196",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("196")])]), _vm._v(" Then would come the long haul uphill to the Evans home. Pat recited satiric verses of his own composition about their acquaintances:")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("She was not chaste, but then she was not willing,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("He didn’t like it, but he had to lump it.")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("But now he finds himself, Ah me how thrilling,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Playing a hot tune on the muted strumpet."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn197",
      "id": "ich02fn197",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("197")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Nancy found such ribaldry distasteful, although she loved the Durrell family and the cultural life of Bournemouth after the hermit existence at Loxwood. Both Larry and Nancy enjoyed a visit to the home of Mrs. Penry, a wealthy American lady who was the Commins Bookshop’s best customer. Once Nancy admired a fine volume on Byzantine painting and Mrs. Penry gave it to her on the spot. After a long and appreciative browse through her exquisite library, Larry sank into a chair, sighing, ‘I’m glutted!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn198",
      "id": "ich02fn198",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("198")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry also kept up his London connections, visiting friends and talking literary shop. On one visit he saw in a pub—but did not speak to—T. E. Lawrence, and subsequently sketched from memory in pen and watercolours the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Seven Pillars of Wisdom")]), _vm._v(". ‘I’ve lost every shred of interest I had in him…. Poor little fellow’, Larry later commented to Alan "), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Thomas.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn199",
      "id": "ich02fn199",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("199")])]), _vm._v(" Through Joseph Allen and the Caduceus Press, Larry arranged to have a small collection of poetry privately printed towards the end of 1934 under the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transition: Poems")]), _vm._v(". Mrs. Penry bought a copy and a somewhat abashed Larry inscribed it to her: ‘For Mrs. Penry who, after collecting one of the finest libraries in England, chose, of her own free will, to place this minnow among the tritons.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn200",
      "id": "ich02fn200",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("200")])]), _vm._v(" If not exactly prize fish, some of the poems in the volume showed a real advance in individual voice over "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quaint Fragment")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ten Poems")]), _vm._v(", although still there is some straining for effect in the manner of the Metaphysicals:")]), _vm._v(" "), _c('p', {
    staticClass: "block2"
  }, [_vm._v("A smile is an expression of despairs,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("With mouth a hanging flap,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("A slip of skin twiddled by subcutaneous hairs,")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("A juggling parody of what you say."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn201",
      "id": "ich02fn201",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("201")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a rare nod to the brother he often teased, Larry dedicated "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transition")]), _vm._v(" to ‘"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LESLIE WHO LIKED ONE")]), _vm._v("’, the poem ‘Wheat-Field.’ ‘I have been rooted wheat,’ Larry wrote, standing grain that a ‘man in a red coat…. destroys / Under a dancing sun.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn202",
      "id": "ich02fn202",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("202")])]), _vm._v(" The images of destruction appealed to Leslie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By mid-July 1934 George Wilkinson was writing from the Tyrol, where he and Pam were pausing on their bicycle trip to Corfu via Trieste. George and Pam were to ride some 1115 miles all told, and when they finally arrived on the island, they discovered that their heavy baggage had been sent via the Cape of Good Hope and was still somewhere in transit. George gave a comic recital of the drawbacks of life on Corfu: the lavatory smelled and the mosquitoes bit. Larry and Nancy might in other circumstances have taken George’s complaints seriously, but Bournemouth increasingly struck Larry as ‘bloody’, so when George suggested, ‘Why not come out here for a spell?’ Larry began to consider moving. Living was cheap, George said; they were having a boat built for £8 and shoes made for fifteen shillings."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn203",
      "id": "ich02fn203",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("203")])]), _vm._v(" Then George added that he was writing well and had finished 18,000 words of a travel book to be illustrated by the photographs Pam had taken en route. Cassell, meanwhile, had communicated not a peep to Larry about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", and in a typically absolute judgement he assumed that he had failed in England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry’s letter in response to George’s invitation announced that they would come, and enquired about schooling for Gerald. George fired back in some alarm, ‘D’you all intend coming (!) and how many is all?’ The answer was quite simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" of them. Larry did a lot of complaining about his mother and siblings, but the ties were powerful. It was as if he could not "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("bear to repeat the long Indian separation. He rejected the head of the family role, but he needed the warm circle that Louisa provided. His mother, Leslie, Margo and little Gerry must come along.")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Years later Larry would attempt somewhat disingenuously to rationalize his decision: ‘I had decided to drop everything, and the only place where one could live on next to nothing then was Greece, especially the islands…. It was quite by chance that Corfu was the first place I went to. I might easily have picked some more remote Greek island.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn204",
      "id": "ich02fn204",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("204")])]), _vm._v(" Writing at the time to George, Larry was less tepid:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Corfu is the ideal place to use as a base for Mediterranean exploration: Nancy is rabid to examine the traces of early Byzantine painting down that coast of Greece, while I am mad to get to Knossos and examine the traces of a Minoan civilization, of which by this time I’m quite sure, my ancestors were a part. Do you know that the average height of the race was five four? Think it over. They were sturdy and lustful…."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn205",
      "id": "ich02fn205",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Larry would list his height in his 1935 passport, generously, as five feet four inches, but in a later passport, in 1944, a ruthlessly accurate clerk would set him down as five feet two. Although he pretended that it did not matter, Larry remained conscious of his shortness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry used the financial argument to convince his mother to live abroad. Louisa, whether following her whims or heeding the financial advice of bankers and solicitors, had continued to lose capital. Larry declared that it would be a good idea to move to inexpensive Corfu for a few years to give the exchequer a chance to recover. For once, Larry’s siblings took his side unanimously, and Louisa said, ‘Yes, dear, I suppose you’re right.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn206",
      "id": "ich02fn206",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("206")])]), _vm._v(" Larry wrote to George, ‘Being too timid to tackle foreign landscapes herself, she wants to be shown around the Mediterranean by us.’ Privately, Larry had doubts. He was apprehensive about the strategic role the Balkan region would play in a European conflict: Corfu was too close to Albania for comfort, and Britain would want to use Greece as a base of operations for protecting the Suez route. ‘What I want to know is, will you, Wilkinson, give your life for gallant little Greece, our gallant little ally? I thought not. Then move a few islands south.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn207",
      "id": "ich02fn207",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("207")])]), _vm._v(" Larry also worried about the instability of Greek politics, what with the talk of restoring the monarchy. George reminded him that in their Loxwood days they had decided that ‘if you want to avoid war Tristan da Cunha is the only place.’ He added sarcastically, ‘Cooks’ll put you onto a good sea route to it, no doubt.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn208",
      "id": "ich02fn208",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By January, Larry’s doubts had diminished, and to lard his resolve, he got "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("an unemployed Bournemouth schoolmaster, Stooks, to refresh his Greek.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn209",
      "id": "ich02fn209",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("209")])]), _vm._v(" The Wilkinsons wrote with advice about steamers versus rail transport: ‘Don’t send your excess luggage over land …. Bring warm clothes for winter: it doesn’t last long but what there is of it is cold & wet.’ This letter ends with a friendly summons: ‘We, and I think I may say that I speak for the island, await your arrival impatiently.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn210",
      "id": "ich02fn210",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("210")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Not one of the Durrells, Indian transplants that they were, seems to have felt at home in England. Louisa thought most of her neighbours, whether in Dulwich, in Parkstone or in Bournemouth, stiff and unfriendly. Leslie had not done well scholastically. Margaret was still boarding at Malvern, and although her marks were good and she was at the top of the tennis team, she was restless. She had come home for the Christmas holidays with a bad cold and was determined not to return. Her siblings agreed, contending that education was useless. Alan Thomas was present when her eiderdown, mailed in a huge parcel by the school, was carried in by the postman. ‘Look!’ exclaimed Larry. ‘Here comes the manuscript of my novel, back from the publishers!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn211",
      "id": "ich02fn211",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("211")])]), _vm._v(" And Gerry had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" liked school: his zoological avocation had always struck him as far more important than sitting on a hard bench listening to incomprehensible nonsense. Louisa, arguing for stability, responsibility and propriety, was outnumbered and seriously out-gunned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After months of haunting the letterbox for news from Cassell or Spencer Curtis Brown, the literary agent he had been lucky enough to acquire, Larry had given up hope. Still, he consoled himself that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("writing")]), _vm._v(" had been useful for him, although he considered himself a poet, not a novelist. He had composed the novel partly for exercise, partly to give colouring to his year at Loxwood and in part for the chance of prize money. He later said that ‘I wrote "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" to prove to my family that I was a writer.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn212",
      "id": "ich02fn212",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("212")])]), _vm._v(" Larry’s enigmatic dedication, scrawled as an apparent afterthought on the typescript in lieu of his intended literary epigraph, reads: ‘For my mother, but for whom …’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn213",
      "id": "ich02fn213",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("213")])]), _vm._v(" In fact, the novel was a valuable exercise for the young writer: it was proof of discipline and accomplishment, and it purged from Larry’s literary system his nostalgically recalled childhood in India. He needed distance from India in order to comprehend England and the Continent.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("With Corfu to look forward to in the spring and with the strain of writing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" behind them, Larry and Nancy passed a good "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("winter in Bournemouth. Alan infected Larry with his own love of classical music and introduced him to Jack Crawshaw, a remarkable amateur musician. Crawshaw played his piano for them and encouraged them to appreciate César Franck’s Sonata for Violin and Piano. Larry and Nancy went to concerts many weekdays, with Alan joining them for Celebrity Concerts on Saturdays. They heard a succession of renowned soloists, among them Cortot, Myra Hess and Rubinstein. The most memorable performance, Nancy thought, was of Beethoven’s Piano Concerto No. 4, played by Moiseiwitsch. Larry and Nancy bought a Ginn gramophone and collected a few records: Beethoven’s Second, Fourth, and Fifth piano concerti, Ravel’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daphnis and Chloe")]), _vm._v(", Myra Hess playing ‘Jesu, Joy of Man’s Desiring’—but no Mozart and no T chaikovsky. Bournemouth had an active theatrical programme, and they saw Noel Coward’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hay Fever")]), _vm._v(", Somerset Maugham’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Circle")]), _vm._v(", and whatever else the Bournemouth repertory theatre produced. Alan enticed Larry and Nancy to what he considered uplifting lectures on literary subjects, including a series on literary ‘Giants’, but Alan finally had to conclude that ‘Larry was never very keen on uplift.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn214",
      "id": "ich02fn214",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("214")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry may have been loud in his complaints about England, loud in his mockery, yet he was conscious also of the good times. In the New Year’s inscription he wrote for 1935 in Alan Thomas’s copy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transition: Poems")]), _vm._v(", everything he said was accurate except, characteristically, the spelling of Alan’s name: ‘To my dear Allen, in poignant memory of a boiled egg, huge laughter, sunburn, wine, the renaissance, a César Franck canon, Beethoven’s 7"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(", despair, dancing, rain, Christ-Church Priory, bellyache, G.K’s satires, lovely books, enthusiasm, train-rides, Bournemouth, and a post-Christmas Constipation.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn215",
      "id": "ich02fn215",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("215")])]), _vm._v(" It was a fitting summary of his time in Bournemouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast to such private admissions, Larry’s public pronouncements on Pudding Island were less kind, yet like another fugitive writer, D. H. Lawrence, he was indelibly marked by England. He had gathered a great load of useful impedimenta to carry into exile: he had been shaped in part by his English education, by his memories of south London, Kent and Sussex, by the British Museum and the Fitzroy Tavern, by Turner’s paintings. Perhaps because the inoculation of Englishness began only after an exotic and often idyllic colonial boyhood, Larry would take a centrifugal course, fleeing England, while Lawrence remained a son of the Midlands, centripetal, looking back towards England with mixed scorn and yearning. Larry was quick, however, to identify with Lawrence: ‘When I "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("first started to write I was very struck by one of D. H. Lawrence’s essays which showed up just how that country treated its writers. That was what made me resolve always to swim against the current.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn216",
      "id": "ich02fn216",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("216")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between the ages of eleven and twenty-three Larry had crowded a great deal into his life, layering experiences in his memory like pledges in a pawnshop, some to be redeemed in fiction, others to lie forgotten: bad debts. Larry’s memories of England would focus on people. Later, in a nostalgic mood on Corfu, Larry would write two stanzas of verse headed ‘England, my England’, probably referring to Lawrence’s short story. The narrator will not remember England, wrote Larry, for her rivers, moorlands, ‘The weeping weeping scourges of the rain’, or even for her ‘heroes’, Chaucer and Shakespeare. Rather, ‘as a lover must’, he will remember four women, ‘Four faces … fixed in your seasons.’ He describes them in order: the ‘slender April woman with the leaning mouth’, ‘that summer kingcup beauty’, a ‘selfless and melancholy autumn girl’, and ‘Even the poor December one I dare not think upon.’ The poet-persona promises, ‘I will remember them, all of them, in you —.’ There is a risk in reading these lines as straight autobiography, with Nancy as the ‘you’ addressed. Larry’s eye ranged over other women, and there are persistent hints that he had known an unidentified woman who died young. Such a figure appears in almost every Durrell novel, beginning with the doomed Ruth of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(", and in various poem drafts of the 1930s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry and Nancy decided to get married before leaving for Corfu. Perhaps it was because George Wilkinson had told them he thought honeymooners could get an eighty per cent fare reduction on Italian rail tickets. The wedding was kept secret from the family, for reasons known only to the principals: maybe they saw it as striking their emancipated colours, or Larry simply shied away from the fuss he knew his mother would make. The young couple did not fear opposition. Louisa was fond of Nancy, and was indeed delighted when they chose to tell her some weeks later. Alan was originally to be one of the witnesses, but Larry said he was worried that tall Nancy and tall Alan, who looked such a perfect couple, would find that the registrar had hitched them up by mistake. An attempt to get a pair of midgets from a local carnival to act as witnesses failed when the employer refused to let his star attractions go. Alan was pressed back into service, and Larry told him to find, as the requisite second witness, ‘someone who knows nothing about us.’ Alan picked Jack Watts, who had just arrived in Bournemouth to take a job in an office across the street from the Commins Bookshop. There was a mutual shock of recognition between "), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("witness and bridegroom before the marriage proceeded: Watts had lived in Bloomsbury, where he had known all of Larry’s London circle. Larry wanted the registrar to use a copy of Rabelais instead of the Bible for the oaths, and the man was quite insulted. ‘You’re taking this deeply serious thing very lightly,’ he scolded an unabashed Larry.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn217",
      "id": "ich02fn217",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("217")])]), _vm._v(" Then Larry discovered that he had left his ring and Nancy’s on Louisa’s mantelpiece.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The threatened flight of the Durrells to Corfu was a blow to Alan, so much had the social evenings at Wimborne Road, the shared concerts and the walks in the New Forest meant to him. As a consolation, Leslie promised to do his best to write from Greece with ideas for songs. Larry had a solution, of course: Alan should come too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alan Thomas, later to become one of England’s leading antiquarian booksellers, was already an expert on mediaeval architecture and monumental brass. He took Larry a last time to Christchurch Priory, a few miles east of Bournemouth, and pointed out the Norman sections built by Ranulph Flambard, who had gone on to design Durham Cathedral. Alan and Larry ascended the bell tower, Alan ducking his tall form carefully under the lintels and Larry bounding up the tight spiral stairs. Then they followed the dark passages between the vaulting and the timbers out on to the roof itself, from which they could view town, harbour, the water-meadows, the Stour and Avon broadening and uniting at the sea. It was a Saturday afternoon and dusk found them still aloft, vivid with plans and speculations. The vespers bell before evensong rocked the very tower on which they stood and hurried them off. ‘It was from this point of departure’, said Alan, ‘that we each set out in different directions, he into the future, I back into the past.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn218",
      "id": "ich02fn218",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("218")])]), _vm._v(" Larry too was aware that they had reached personal epiphanies, as he wrote to Alan from Corfu in a letter that would later appear in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("I was thinking tonight of those summer days in the shadow of the priory. They seem to belong to another world—a world of shapes which included such colours as warmth, charity, love, etc. A whole dormant Platonic principle which, in its essence, is England—the marrow and bone of England. This is a very necessary valediction, not only to England, but, if you like, to the world. It will hurt you, but it is the truth. I have looked into my account—the account that seemed so full and heavy with new cash—and found hardly a coin that will ring properly on wood. There was nothing for it but to empty my wallet into the dust and take the road again: without dramatics this time, without heroics …. It is queer to remember that this decision was already shaping itself that afternoon, when we stood on the southern tower of the priory, hanging in the breeze, breathless and exulting like sea birds. All that was "), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("the island then, was represented in that humorous razored profile of yours—the predatory nose of the Middle Ages, the Goth singing in your blood, the music you gathered up in those nervous fingers and transmitted, crazy with your own enthusiasm…. It was in that time that I began dimly to see the equation which was finally printed in my brain here, over the Ionian. It was the temptation of the devil, the vision of the cities offered to me from an immense mountaintop. The devil! What should be more plausible than that you should be the Black Saint himself—panurgic, long-nosed, calculating bastard that you are! You were offering me, in your oblique way, the whole of England—the masques, the viols, the swans, the mists, the doom, the fogs: you were offering me a medieval death in which I could live forever, stifled in the pollen of breviaries, noctuaries, bestiaries: split silk and tumbrils, aesthetic horses and ruined Abbeys.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn219",
      "id": "ich02fn219",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("219")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry did not escape completely from the devil’s temptation, although he had come to realize that he could never be rootedly English, that he must escape England: ‘I am, and I remain, an expatriate’, he was to tell Marc Alyn almost four decades later; ‘that vague sense of exile has never quite left me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn220",
      "id": "ich02fn220",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("220")])]), _vm._v(" At the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper of Lovers")]), _vm._v(" Larry had Walsh say of England, ‘I feel I’ve been imprisoned for a long time.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn221",
      "id": "ich02fn221",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("221")])]), _vm._v(" In retrospect, the decision might appear to have been an easy one for Larry. In the event it was not. Despite his frequent protestations of unhappiness, England had gained a powerful hold upon his being, and upon his affections: Platonic and scholastic England, Chaucer’s England, Shakespeare’s and Turner’s England, even the mundane England of convivial pubs and pork sausages for breakfast. For all this Alan, lean aesthetic lover of the many Englands, was no mean advocate. Still, Larry had set his mind on exile and escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry got his passport with only two days to spare, listing his profession as ‘Journalist.’ ‘Just managed to catch bus, train, boat, breakfast, taxi and whatnot—’ wrote Nancy to Alan; ‘looks as though we’re all going to be real pals and one big family on this boat.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn222",
      "id": "ich02fn222",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("222")])]), _vm._v(" “Never Come Back” is our epitaph, our requiem, our good-bye’, Larry had written in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied Piper")]), _vm._v(", as his hero and heroine leave England."), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#ch02fn223",
      "id": "ich02fn223",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("223")])]), _vm._v(" Larry might have believed that he was done with Britain: none the less, Christchurch Priory, Southwark Cathedral, a jury of Elizabethan writers, and the suavely tempting form of the devil himself travelled along in his packing case. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Avignon Quintet")]), _vm._v(", especially in the first volume, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monsieur, or, The Prince of Darkness")]), _vm._v(", Larry was to revisit the Middle Ages of his friend Alan. But that was many years away when Larry and Nancy slipped past Grays on the Thames and the present crowded upon them.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebe6998c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter02.vue
// module id = 81
// module chunks = 0